import React, { useEffect, useMemo, useRef, useState } from "react";
import { all_routes } from "../../router/all_routes";
import { Link } from "react-router-dom";
import Table from "../../../core/common/dataTable/index";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import { DatePicker, Drawer, message, Modal, Typography } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../core/data/redux/store";
import { createChild, createEmployeeDocument, createExperience, createTopSkill, deleteEmployee, fetchEmployeeAnalytics, getEmployeeById, getEmployees, updateChild, updateEmployeeDocument, updateExperience, updateTopSkill, FetchAlljobLocation, updateemployeeleave, createemployeeleave, getUppderLevelById, deleteemployeeleave, deleteEmployeeExperience, deleteEmployeeSkill, deleteEmployeeChild, deleteEmployeeDocument, deleteEmployeeProfilePic } from "../../../core/data/redux/employee/employeeAction";
import { fetchAllDepartments } from "../../../core/data/redux/department/departmentAction";
import { fetchAllDesignations } from "../../../core/data/redux/designation/designationAction";
import { fetchAllRoles } from "../../../core/data/redux/user/role/roleAction";
import { filterData } from "../../../core/common/GlobalFunctions/tableFilters";
import { exportToCSV, exportToExcel, exportToPDF, } from "../../../core/common/GlobalFunctions/exportTableData";
import DeleteModal1 from "../../../core/modals/deleteModal1";
import { fetchALlSkill } from "../../../core/data/redux/skill/skill.Action";
import { useEmployeeCSVImport } from "../../../customhooks/useEmployeeCSVImport";
import { fetchAllEmployeelogById } from "../../../core/data/redux/employeelog/employeelog.Action";
import { fetchAllBranch } from "../../../core/data/redux/branch/branch.Action";
import { fetchAllLeaveTypes } from "../../../core/data/redux/attendance/leaveTypes/LeaveTypeActions";
import { formatDate, formatFullDateTime } from "../../../core/utils/configFormatters";
import { useAppConfig } from "../../../customhooks/useAppConfig";
import { filterByStatus } from "../../../core/utils/filterActiveData";
import { decryptData } from "../../../core/utils/encryptUtils";
import { Tabs, Form, Button, Select, Row, Col, Card, Divider, Space } from 'antd';
import { EditOutlined, CheckOutlined } from '@ant-design/icons';
import { UploadFile } from 'antd/es/upload';
import dayjs, { Dayjs } from "dayjs";
import { useBasicInfo } from "../../../customhooks/useBasicInfo";
import { status } from "../../../core/common/selectoption/selectoption";
import { useQualificationForm } from "../../../customhooks/useQualificationForm";
import { usePartnerForm } from "../../../customhooks/usePartnerForm";
import { useGuardianForm } from "../../../customhooks/useGuardianForm";
import { fetchingexperience } from "../../../core/data/redux/experience/experience.Action";
import EmployeeSalaryStructureModal from "./modal/EmployeeSalaryStructureModal";
import { useEducationCSVImport } from "../../../customhooks/useEmployeeEducationCSVImport";
import { useSkillCSVImport } from "../../../customhooks/useEmployeeSkillimport";
import { resetCreatedEmployeeId, setCreatedEmployeeId } from "../../../core/data/redux/employee/employeeSlice";

const genderOption = [
    { value: "0", label: "Select" },
    { value: "1", label: "Male" },
    { value: "2", label: "Female" },
    { value: "3", label: "Others" },
];

type PasswordField = "password" | "confirmPassword";

const { TabPane } = Tabs;
const { Option } = Select;
const { Title, Text } = Typography;

enum EmploymentType {
    FullTime = "Full-time",
    PartTime = "Part-time",
    Contract = "Contract",
    Freelance = "Freelance",
    Internship = "Internship",
}

enum WorkPreference {
    "Work from Office" = "Work from Office",
    "Client-side" = "Client-side",
    "Remote" = "Remote",
}

interface Experience {
    id?: number;
    companyName: string;
    jobTitle: string;
    startDate: string;
    endDate: string;
    reasonForLeaving: string;
    companyLocation: string;
    salary: any;
    employmentType: string;
    jobDescription: string;
}

interface Child {
    id: number;
    name: string;
    dob: Dayjs | null;
    gender: string;
}

interface Skill {
    id: number;
    name: string;
    proficiency: number;
}
interface Document {
    id: number;
    documentType?: string;
    Name?: string;
    documentNumber: string;
    file?: File | null;
    additionalNotes: string;
    accessDoc: string;
}

const documentTypes: string[] = [
    "aadhar",
    "pan",
    "driving-license",
    "passport",
    "voter-id",
    "ghana-card",
    "highschool",
    "senior-secondary",
    "graduation",
    "post-graduation",
    "other",
];

interface EditingSections {
    basic?: boolean;
    spouse?: boolean;
    parents?: boolean;
    children?: boolean;
    additional?: boolean;
    job?: boolean;
    employment?: boolean;
    location?: boolean;
    address?: boolean;
    document?: boolean;
    salaryStructure?: boolean;
    skills?: boolean;
    education?: boolean;
    experience?: boolean;
    leave?: boolean;
    [key: string]: boolean | undefined;
}

interface EditingSectionsSalaryStruct {
    EditsalaryStructure: boolean;
    [key: string]: boolean | undefined;
}

const EmployeeList = ({ onClose }: any) => {
    const createdEmployeeId = useSelector((state: RootState) => state.employee.createdEmployeeId);
    const dispatch = useDispatch<AppDispatch>();
    const [selectedStatus, setSelectedStatus] = useState("active");
    const [selectedSort, setSelectedSort] = useState<any>("");
    const [tableKey, setTableKey] = useState(0);
    const { branch } = useSelector((state: any) => state.branch);
    const { employees, createEmployeeLoading, updateEmployeeLoading } = useSelector((state: any) => state.employee);
    const { employee } = useSelector((state: any) => state.employee);
    const { EmployeeAnalytics } = useSelector((state: any) => state.employee);
    const { user } = useSelector((state: any) => state.auth);
    const { employeeFullDetails } = useSelector((state: any) => state.employee);
    const EmployeeId = employeeFullDetails?.employee[0]?.EmployeeID
    const [employeelogs, setemployeelog] = useState<any>(null);
    const { departments } = useSelector((state: any) => state.department);
    const { designations } = useSelector((state: any) => state.designation);
    const { roles } = useSelector((state: any) => state.role);
    const { skill: skillMaster } = useSelector((state: any) => state.skill);
    const [isDeleteModalVisible, setIsDeleteModalVisible] = useState<boolean>(false);
    const rolesData = roles ? roles : [];
    const departmentData = departments ? departments : [];
    const designationData = designations ? designations : [];
    const [joblocation, setjoblocation] = useState<any>([]);
    const { leaveTypes } = useSelector((state: any) => state.attendance.leaveTypes);
    const [selectedRowData, setSelectedRowData] = useState<any>(null);
    const { spouseData, handleSpouseChange, setSpouseData, handleSpouseSubmit, spouseErrors, resetSpouseForm, validateSpouse } = usePartnerForm();
    const { parentData, handleParentChange, handleParentSubmit, parentErrors, setParentData, resetParentForm, validateParent } = useGuardianForm();
    const { educationData, handleEducationChange, handleEducationSubmit, educationErrors, setEducationData, resetEducationForm, validateQualification } = useQualificationForm();
    const [isModalVisible, setIsModalVisible] = useState<boolean>(false);
    const [modalType, setModalType] = useState<"edit" | "create" | "">("");
    const { handleCSVImport } = useEmployeeCSVImport(setTableKey);
    const fileInputRef = useRef<HTMLInputElement | null>(null);
    const [viewModalOpen, setViewModalOpen] = useState(false);
    const basicInfoTabRef = useRef<HTMLButtonElement | null>(null);
    const tabContentRef = useRef<HTMLDivElement | null>(null);
    const [showSampleModal, setShowSampleModal] = useState<any>(false);
    const [showSampleModalEducation, setShowSampleModalEducation] = useState<any>(false);
    const [showSampleModalSkill, setShowSampleModalSkill] = useState<any>(false);
    const activeEmployeeDesignation = filterByStatus(designations, 'active', 'DesignationStatus');
    const activeDepartment = filterByStatus(departmentData, 'active', 'Status');
    const activeReportingManager = filterByStatus(employees, 'active', 'employee_status');
    const activeHR = filterByStatus(employees, 'active', 'employee_status');
    const activeHOD = filterByStatus(employees, 'active', 'employee_status');
    const ActiveBranch = filterByStatus(branch, 'active', 'Status');
    const activeSkill = filterByStatus(skillMaster, 'active', 'status');
    const activeLeaveType = filterByStatus(leaveTypes, 'active', 'Status');
    const [loadingSpouse, setLoadingSpouse] = useState(false);
    const [loadingJobInfo, setLoadingJobInfo] = useState(false);
    const [locationInfoLoading, setLocationInfoLoading] = useState(false);
    const [loadingEmployement, setLoadingEmployement] = useState(false);
    const [loadingSkill, setLoadingSkill] = useState(false);
    const [loadingLeave, setLoadingLeave] = useState(false);
    const [loadingDocument, setLoadingDocument] = useState(false);
    const [selectedDocumentIndex, setSelectedDocumentIndex] = useState(null);
    const [mapExperience, setMapExperience] = useState([]);
    const [loadingSalary, setLoadingSalary] = useState(false);
    const activeExperience = filterByStatus(mapExperience, 'active', 'Status');
    const { handleEducationCSVImport } = useEducationCSVImport(setTableKey);
    // const educationFileInputRef = useRef<HTMLInputElement | null>(null);

    const { handleSkillCSVImport } = useSkillCSVImport(setTableKey);

    // const triggerImportSkillFileSelect = () => fileInputRef.current?.click();

    const handleImportSkillFileChange = (e: any) => {
        const file = e.target.files[0];
        if (file) handleSkillCSVImport(file);
    };


    const employeeFileInputRef = useRef<HTMLInputElement>(null);
    const educationFileInputRef = useRef<HTMLInputElement>(null);
    const skillFileInputRef = useRef<HTMLInputElement>(null);



    const triggerImportFileSelect = () => {
        employeeFileInputRef.current?.click();
    };

    const triggerEducationImport = () => {
        educationFileInputRef.current?.click();
    };

    const triggerImportSkillFileSelect = () => {
        skillFileInputRef.current?.click();
    };




    const downloadSampleEducationFormat = [
        {
            Employee: "Aman Sharma",
            EducationType: "Bachelor",
            Degree: "B.Tech (CSE)",
            StartYear: "2019",
            EndYear: "2023",
            Percentage: "78%",
            SchoolName: "AKTU University"
        }
    ];

    const sampleSkillCSV = [
        {
            Employee: "Ram",
            SkillName: "Cloud Computing",
            ProficiencyScore: 9,
        },
        {
            Employee: "Shayam",
            SkillName: "React.js",
            ProficiencyScore: 8,
        },
        {
            Employee: "Mohan",
            SkillName: "Node.js",
            ProficiencyScore: 7,
        }
    ];



    const [accessDoc, setAccessDoc] = useState<string>("");
    const leaveTypesData = modalType === 'create' ? createdEmployeeId : selectedRowData

    const getFilteredLeaveTypes = (employee: any, leaveTypes: any[]) => {
        if (!employee) return [];

        return leaveTypes.filter((leave) => {
            if (leave.Gender === "Both") return true;
            if (employee.GenderId === 1 && leave.Gender === "Male") return true;
            if (employee.GenderId === 2 && leave.Gender === "Female") return true;
            return false;
        });
    };
    // Usage
    const filteredLeaveTypes = getFilteredLeaveTypes(leaveTypesData, activeLeaveType);
    const config = useAppConfig();

    // form interface
    interface PersonalInfo {
        firstName: string;
        lastName: string;
        dateOfBirth: Date | null;
        gender: string;
        username: string;
        email: string;
        password: string;
        confirmPassword: string;
        employmentType: string;
        joiningDate: Date | null;
        workPreference: string;
        reportingManager: string;
        hr: string;
        hod: string;
        phone: string;
        company: string;
        department: string;
        designation: string;
        role: string;
        status: string;
        branch: string;
        jobLocation: string;
        about: string;
        epfEnabled: boolean;
        trackLocation: boolean;
    }

    interface SpouseDetails {
        name: string;
        dob: Date | null;
        phone: string;
        email: string;
        occupation: string;
        employer: string;
        nationality: string;
        anniversaryDate: Date | null;
        about: string;
        address: string;
    }

    interface FormData {
        [key: string]: any;
        personalInfo: PersonalInfo;
        spouseDetails: SpouseDetails;
        childrenDetails: Array<{
            id: number;
            name: string;
            dob: Date | null;
            gender: string;
        }>;
        skills: Array<{
            id: number;
            name: string;
            proficiency: number;
        }>;
        education: Array<{
            highestEducation: string;
            fieldOfStudy: string;
            institution: string;
            graduationYear: Date | null;
            startDate: Date | null;
            endDate: Date | null;
            address: string;
            gpa: string;
            description: string;
        }>;
        documents: Array<{
            type: string;
            number: string;
            file: UploadFile | null;
            notes: string;
        }>;
        experience: Array<{
            company: string;
            jobTitle: string;
            startDate: Date | null;
            endDate: Date | null;
            reasonForLeaving: string;
            location: string;
            salary: string;
            employmentType: string;
            description: string;
        }>;
        leave: Array<{
            type: string;
            days: number;
            applicableFrom: Date | null;
        }>;
    }

    // Initial form data state
    const initialFormData: FormData = {
        personalInfo: {
            firstName: '',
            lastName: '',
            dateOfBirth: null,
            gender: '',
            username: '',
            email: '',
            password: '',
            confirmPassword: '',
            reportingManager: '',
            hr: '',
            hod: '',
            joiningDate: null,
            employmentType: '',
            workPreference: '',
            phone: '',
            company: '',
            department: '',
            designation: '',
            role: '',
            status: '',
            branch: '',
            jobLocation: '',
            about: '',
            epfEnabled: false,
            trackLocation: false
        },
        spouseDetails: {
            name: '',
            dob: null,
            phone: '',
            email: '',
            occupation: '',
            employer: '',
            nationality: '',
            anniversaryDate: null,
            about: '',
            address: ''
        },
        childrenDetails: [],
        skills: [],
        education: [],
        documents: [],
        experience: [],
        leave: []
    };

    const initialExperienceState: Experience = {
        companyName: '',
        jobTitle: '',
        startDate: '',
        endDate: '',
        reasonForLeaving: '',
        companyLocation: '',
        salary: '',
        employmentType: 'full-time',
        jobDescription: ''
    };

    const [formData, setFormData] = useState<FormData>(initialFormData);
    const [form] = Form.useForm();
    const [activeTab, setActiveTab] = useState('personal');
    const [editingSections, setEditingSections] = useState<EditingSections>({});
    const [editingSlaryStruct, setEditingSalaryStruct] = useState<EditingSectionsSalaryStruct>({
        EditsalaryStructure: false
    });
    const salaryStructRef = useRef<any>(null);
    const [sameAsBranch, setSameAsBranch] = useState(false);
    const [profileImage, setProfileImage] = useState<File | null>(null);
    const [imagePreview, setImagePreview] = useState<string | null>(null);
    const [isNewEmployee, setIsNewEmployee] = useState(true);

    const [showFullDetailsTab, setShowFullDetailsTab] = useState<boolean>(false);
    const encryptedPermissions = localStorage.getItem('currentPermissions');
    const permissions: string[] = Array.isArray(decryptData(encryptedPermissions || '')) ? decryptData(encryptedPermissions || '') : [];
    const canAdd = permissions?.includes("Add") || permissions?.includes("AllowAll");
    const canView = permissions?.includes("View") || permissions?.includes("AllowAll");
    const canEdit = permissions?.includes("Edit") || permissions?.includes("AllowAll");
    const canDelete = permissions?.includes("Delete") || permissions?.includes("AllowAll");
    const canExport = permissions?.includes("Export") || permissions?.includes("AllowAll");
    const canImport = permissions?.includes("Import") || permissions?.includes("AllowAll");

    const [selectedRow, setSelectedRow] = useState<any>(null);

    const [leaves, setLeaves] = useState<any[]>([]);
    const [selectedLeaveIndex, setSelectedLeaveIndex] = useState<number | null>(null);
    const [leaveForm, setLeaveForm] = useState<any>({
        LeaveType: "",
        NumberOfDays: "",
        Frequency: "",
        ApplicableFrom: "",
        CreatedBy: user?.UserId,
        OpeningBalance: ""
    });

    const [passwordVisibility, setPasswordVisibility] = useState({
        password: false,
        confirmPassword: false,
    });

    const togglePasswordVisibility = (field: PasswordField) => {
        setPasswordVisibility(prev => ({
            ...prev,
            [field]: !prev[field]
        }));
    };

    const [employeeTabState, setEmployeeTabState] = useState<{ [key: string]: string }>({});

    // Handle tab change
    const handleTabChange = (key: string) => {
        setActiveTab(key);

        if (selectedRowData?.EmployeeID) {
            setEmployeeTabState(prev => ({
                ...prev,
                [selectedRowData.EmployeeID]: key
            }));
        }
    };

    useEffect(() => {
        if (isModalVisible && selectedRowData?.EmployeeID) {
            const savedTab = employeeTabState[selectedRowData.EmployeeID] || 'personal';
            setActiveTab(savedTab);
        }
    }, [isModalVisible, selectedRowData, employeeTabState]);

    // Toggle edit mode for sections
    const toggleEdit = (section: string) => {
        setEditingSections(prev => ({
            ...prev,
            [section]: !prev[section]
        }));
    };
    const toggleEditSalaryStruct = (section: string) => {
        setEditingSalaryStruct((prev) => ({
            ...prev,
            [section]: !prev[section],
        }));
    };

    //Global Save Function
    const validateExperience = async (): Promise<{ isValid: boolean; missingFields?: string[] }> => {
        const missingFields: string[] = [];
        if (!newExperience.companyName) missingFields.push("Company Name");
        if (!newExperience.jobTitle) missingFields.push("Job Title");
        if (!newExperience.startDate) missingFields.push("Start Date");
        if (!newExperience.endDate) missingFields.push("End Date");
        if (!newExperience.reasonForLeaving) missingFields.push("Reason For Leaving");
        if (!newExperience.companyLocation) missingFields.push("Company Location");
        if (!newExperience.salary) missingFields.push("Salary");
        if (!newExperience.employmentType) missingFields.push("Employment Type");

        if (newExperience.startDate && newExperience.endDate) if (new Date(newExperience.startDate) > new Date(newExperience.endDate)) missingFields.push("Start date cannot be after end date.");
        return { isValid: missingFields.length === 0, missingFields };
    };

    const validateChildren = async (): Promise<{ isValid: boolean; missingFields?: string[] }> => {
        const missingFields: string[] = [];

        if (!childName) missingFields.push("Child Name");
        if (!childDob) missingFields.push("Child Date of Birth");
        if (!childGender) missingFields.push("Child Gender");

        if (missingFields.length === 0) {
            return { isValid: true, missingFields: [] };
        }

        if (children && children.length > 0) return { isValid: true, missingFields: [] };

        return { isValid: false, missingFields };
    };

    const validateLeaves = async (): Promise<{ isValid: boolean; missingFields?: string[] }> => {
        const missingFields: string[] = [];

        if (!leaveForm.LeaveType) missingFields.push("Leave Type");
        if (!leaveForm.NumberOfDays) missingFields.push("Number of Days");
        if (!leaveForm.ApplicableFrom) missingFields.push("Applicable From");

        return { isValid: missingFields.length === 0, missingFields };
    };

    const validateSkills = async (): Promise<{ isValid: boolean; missingFields?: string[] }> => {
        const missingFields: string[] = [];

        if (!skillName) {
            missingFields.push("Skill Name");
        }
        if (!proficiency || Number(proficiency) < 1 || Number(proficiency) > 10) {
            missingFields.push("Proficiency Score");
        }

        if (missingFields.length === 0) {
            const success = await handleAddOrUpdateAndSaveSkill(false);
            return { isValid: success, missingFields: success ? [] : ['Failed to save skill'] };
        }

        if (skills && skills.length > 0) {
            return { isValid: true, missingFields: [] };
        }

        return { isValid: false, missingFields };
    };

    const hasUnsavedOrDuplicateDocuments = (): boolean => {
        const hasUnsaved = !!documentType || !!documentNumber || !!file || !!additionalNotes || !!accessDoc

        const filteredTypes = documents
            .map(doc => doc.documentType)
            .filter(type => type !== "other");

        const hasDuplicate = filteredTypes.some(
            (type, i) => filteredTypes.indexOf(type) !== i
        );

        return hasUnsaved || hasDuplicate;
    };

    const validateDocuments = async (): Promise<{ isValid: boolean; missingFields?: string[] }> => {
        const missingFields: string[] = [];

        if (documentType !== 'other') {
            if (!documentType) missingFields.push("Document Type");
            if (!documentNumber) missingFields.push("Document Number");
            if (!fileName) missingFields.push("File");

            // pattern check
            if (patterns[documentType] && documentNumber && !patterns[documentType].test(documentNumber)) {
                missingFields.push(`Invalid ${documentType} format`);
            }
        }
        return missingFields.length > 0
            ? { isValid: false, missingFields }
            : { isValid: true, missingFields: [] };
    };

    const hasSpouseData = () => {
        return Object.values(spouseData || {}).some((value) => value?.toString().trim() !== "");
    };

    const hasParentData = () => {
        return Object.values(parentData || {}).some(value => value?.toString().trim() !== "");
    };

    const hasQualificationData = () => {
        return Object.values(educationData || {}).some(
            (value) => value !== null || value !== undefined || value.toString().trim() !== ""
        );
    };

    const salaryStructures = salaryStructRef.current?.salaryStructures || [];
    const employeeSalaryData = salaryStructRef.current?.employeeSalaryData || {};
    const earningsData = salaryStructRef.current?.earningsData || [];
    const deductionsData = salaryStructRef.current?.deductionsData || [];
    const handleSubmit = salaryStructRef.current?.handleSubmit;

    const validateSalaryStructure = async (
        employeeId: number,
        data = employeeSalaryData,
        earnings = earningsData,
        deductions = deductionsData
    ): Promise<{ isValid: boolean; missingFields: string[] }> => {
        const missingFields: string[] = [];

        if (!data?.pay_scale_id || data.pay_scale_id === "") missingFields.push("Pay Scale");
        if (!data?.start_date) missingFields.push("Start Date");
        if (!data?.end_date) missingFields.push("End Date");

        if (missingFields.length > 0) {
            return { isValid: false, missingFields };
        }

        const hasUnsavedInput =
            Object.values(data || {}).some(
                (val) => val !== undefined && val !== null && val !== "" && val !== 0
            ) ||
            earnings?.length > 0 ||
            deductions?.length > 0;

        if (hasUnsavedInput) {
            return { isValid: true, missingFields: [] };
        }

        const employeeStructures = salaryStructures.filter(
            (s: any) => s.employee_id === employeeId
        );

        return employeeStructures.length > 0
            ? { isValid: true, missingFields: [] }
            : { isValid: false, missingFields: ["No salary structure found"] };
    };

    const handleGlobalSave = async () => {
        const isEditMode = modalType === "edit";
        const isCreatedEmployee = createdEmployeeId

        if (!isEditMode && !isCreatedEmployee) {
            const validationResult = validate("full");
            if (!validationResult.isValid) {
                Modal.error({
                    title: "Missing Required Fields",
                    content: (
                        <div style={{ whiteSpace: 'pre-line' }}>
                            {validationResult.missingFields && validationResult.missingFields.length > 0
                                ? `Please fill all required fields:\n${validationResult.missingFields.join('\n')}`
                                : "Please fill all required fields in Basic Information section before saving."
                            }
                        </div>
                    ),
                });
                return;
            }
            const success = await saveAllSections([], true);

            if (success) {
                Modal.info({
                    title: "Additional Sections",
                    content: "Other sections (Employment, Skills, Documents, etc.) can be filled after creating the employee profile.",
                    onOk: () => { handleCancel(); },
                });
            }
            return;
        }
        const sectionsToValidate: any = [
            editingSections.basic && { title: "Basic Information", hasData: true, fn: () => validate("full") },
            editingSections.spouse && { title: "Spouse Details", hasData: hasSpouseData(), fn: () => validateSpouse() },
            editingSections.children && { title: "Children Details", hasData: true, fn: () => validateChildren() },
            editingSections?.parents && { title: "Parents Details", hasData: hasParentData(), fn: () => validateParent() },
            editingSections.additional && { title: "Additional Information", hasData: true, fn: () => validate("additional") },
            editingSections.employment && { title: "Employment Details", hasData: true, fn: () => validate("employement") },
            editingSections.job && { title: "Job Information", hasData: true, fn: () => validate("jobInfo") },
            editingSections.location && { title: "Location Information", hasData: true, fn: () => validate("location_info") },
            editingSections.experience && { title: "Work Experience", hasData: true, fn: () => validateExperience() },
            editingSections.skills && { title: "Skills", hasData: true, fn: () => validateSkills() },
            editingSections?.education && { title: "Education", hasData: hasQualificationData(), fn: () => validateQualification() },
            editingSections.leave && { title: "Leave Information", hasData: true, fn: () => validateLeaves() },
            editingSections.document && { title: "Documents", hasData: hasUnsavedOrDuplicateDocuments(), fn: () => validateDocuments() },
            editingSlaryStruct.EditsalaryStructure && { title: "Salary Structure", hasData: true, fn: () => validateSalaryStructure(selectedRowData?.EmployeeID || salaryStructures?.employee_id, salaryStructRef.current?.employeeSalaryData, salaryStructRef.current?.earningsData, salaryStructRef.current?.deductionsData) },
        ].filter(Boolean);

        const failedSections: { title: string; missingFields?: string[] }[] = [];
        for (const section of sectionsToValidate) {
            const result = await section?.fn();
            if (section.hasData && !result.isValid) {
                failedSections.push({
                    title: section.title,
                    missingFields: result.missingFields
                });
            }
        }

        if (failedSections.length > 0) {
            Modal.warning({
                title: "Validation Failed",
                content: (
                    <div>
                        <p>Oops! Some sections need your attention. Please review and complete them:</p>
                        <ul style={{ maxHeight: "200px", overflowY: "auto" }}>
                            {failedSections.map((section, i) => (
                                <li key={i}>
                                    <strong>{section.title}</strong>
                                    {section.missingFields && section.missingFields.length > 0 && (
                                        <> : {section.missingFields.join(", ")}</>
                                    )}
                                </li>
                            ))}
                        </ul>
                    </div>
                ),
                okText: "OK",
            });
        }
        else {
            const success = await saveAllSections([]);
            if (success) {
                message.success("All fields saved successfully!");
                handleCancel();
            }
        }

    };

    const [isSaving, setIsSaving] = useState(false);
    const saveAllSections = async (skippedSections: string[], isCreateMode = false) => {
        try {
            setIsSaving(true);
            const savePromises = [];
            const mockFormEvent = {
                preventDefault: () => { },
                nativeEvent: {},
                isDefaultPrevented: () => false,
                isPropagationStopped: () => false,
                persist: () => { },
            } as React.FormEvent;

            if (isCreateMode && !createdEmployeeId) {
                const success = await handleEmployeeSubmit(mockFormEvent, 'full', false, true, true);
                if (!success) return false;
            } else {
                if (!skippedSections.includes("Basic Information")) {
                    savePromises.push(handleEmployeeSubmit(mockFormEvent, 'full', false, true, false));
                }
                if (Object.values(spouseData || {}).some(value => value) && !skippedSections.includes("Spouse Details")) {
                    savePromises.push(handleSpouseSubmit(mockFormEvent, true, false));
                }
                const hasNewChildInput = childName.trim() !== "" || childDob !== null || childGender.trim() !== "";
                if ((children.length > 0 || hasNewChildInput) && !skippedSections.includes("Children Details")) {
                    savePromises.push(handleAddOrUpdateChild(false));
                }
                if (Object.values(parentData || {}).some(value => value) && !skippedSections.includes("Parents Details")) {
                    savePromises.push(handleParentSubmit(mockFormEvent, true, false));
                }
                if (!skippedSections.includes("Additional Information")) {
                    savePromises.push(handleEmployeeSubmit(mockFormEvent, 'additional', false, true, false));
                }
                if (!skippedSections.includes("Employment Details")) {
                    savePromises.push(handleEmployeeSubmit(mockFormEvent, 'employement', false, true, false));
                }
                if (!skippedSections.includes("Job Information")) {
                    savePromises.push(handleEmployeeSubmit(mockFormEvent, 'jobInfo', false, true, false));
                }
                if (!skippedSections.includes("Location Information")) {
                    savePromises.push(handleEmployeeSubmit(mockFormEvent, 'location_info', false, true, false));
                }
                const hasNewExperienceData = Object.values(newExperience || {}).some(val => val);
                if ((experiences.length > 0 || hasNewExperienceData) && !skippedSections.includes("Work Experience")) {
                    savePromises.push(handleAddOrUpdateAndSaveExperience(false));
                }
                if (!skippedSections.includes("Skills")) {
                    const hasUnsavedSkills =
                        (skillName && Number(proficiency) >= 1 && Number(proficiency) <= 10) ||
                        skills.some(skill => !skill.id || skill.id === -1);

                    const hasExistingSkills = skills.length > 0;

                    if (hasUnsavedSkills || hasExistingSkills) {
                        savePromises.push(handleAddOrUpdateAndSaveSkill(false));
                    }
                }
                if (editingSections.education && hasQualificationData() && !skippedSections.includes("Education")) {
                    savePromises.push(handleEducationSubmit(mockFormEvent, true, false));
                }
                if ((Object.values(leaveForm || {}).some(val => val)) && !skippedSections.includes("Leave Information")) {
                    savePromises.push(handleAddAndSaveLeaves(false));
                }
                const shouldSaveDocuments = (modalType === "create" && editingSections.document && hasUnsavedOrDuplicateDocuments()) || (modalType === "edit" && editingSections.document && hasUnsavedOrDuplicateDocuments());
                if (shouldSaveDocuments && !skippedSections.includes("Documents")) {
                    const docSaved = await handleAddAndSaveDocument(false);
                    if (!docSaved) {
                        setIsSaving(false);
                        return false;
                    }
                }

                if (!skippedSections.includes("Salary Structure")) {
                    const hasUnsavedInput =
                        Object.values(employeeSalaryData || {}).some(
                            (val) => val !== undefined && val !== null && val !== "" && val !== 0
                        ) ||
                        (earningsData && earningsData.length > 0) ||
                        (deductionsData && deductionsData.length > 0);

                    if ((hasUnsavedInput || (salaryStructures && salaryStructures.length > 0)) && handleSubmit) {
                        savePromises.push(salaryStructRef.current.handleSubmit(false, false));
                    }
                }
            }

            await Promise.all(savePromises.flat());

            if (selectedRowData?.EmployeeID && !isCreateMode) {
                await dispatch(getEmployeeById({ employeeId: selectedRowData.EmployeeID }));
            }

            if (onClose) onClose();
            return true;

        } catch (error: any) {
            console.error("Save all sections error:", error);
            if (error.response?.data?.message) {
                message.error(`Save failed: ${error.response.data.message}`);
            } else {
                message.error("Failed to save employee data. Please try again.");
            }
            return false;
        } finally {
            setIsSaving(false);
        }
    };


    // const saveAllSections = async (skippedSections: string[], isCreateMode = false) => {
    //     try {
    //         setIsSaving(true);
    //         const mockFormEvent = {
    //             preventDefault: () => { },
    //             nativeEvent: {},
    //             isDefaultPrevented: () => false,
    //             isPropagationStopped: () => false,
    //             persist: () => { },
    //         } as React.FormEvent;

    //         let employeeId = createdEmployeeId || EmployeeId || selectedRowData?.EmployeeID;
    //         console.log(employeeId, 'employeeidfdfd')
    //         if (isCreateMode && !createdEmployeeId) {
    //             const success = await handleEmployeeSubmit(mockFormEvent, "full", false, true, true);
    //             if (!success) {
    //                 message.error("Failed to create employee.");
    //                 return false;
    //             }
    //             await new Promise(resolve => setTimeout(resolve, 50));

    //             if (!createdEmployeeId || !EmployeeId) {
    //                 message.error("Failed to create employee.");
    //                 return false;
    //             }
    //             employeeId = createdEmployeeId || EmployeeId;
    //             console.log(employeeId, 'new employeeid')


    //             const saveAfterBasic = [];

    //             if (Object.values(spouseData || {}).some(v => v)) {
    //                 saveAfterBasic.push(
    //                     handleSpouseSubmit(mockFormEvent, true, false, employeeId)
    //                 );
    //             }

    //             const hasNewChildInput =
    //                 childName.trim() !== "" ||
    //                 childDob !== null ||
    //                 childGender.trim() !== "";

    //             if (children.length > 0 || hasNewChildInput) {
    //                 saveAfterBasic.push(
    //                     handleAddOrUpdateChild(false, employeeId)
    //                 );
    //             }

    //             if (Object.values(parentData || {}).some(v => v)) {
    //                 saveAfterBasic.push(
    //                     handleParentSubmit(mockFormEvent, true, false, employeeId)
    //                 );
    //             }

    //             saveAfterBasic.push(
    //                 handleEmployeeSubmit(mockFormEvent, "additional", false, true, false, employeeId)
    //             );

    //             await Promise.all(saveAfterBasic);
    //             return true;
    //         }

    //         const savePromises = [];

    //         if (!skippedSections.includes("Basic Information")) {
    //             savePromises.push(handleEmployeeSubmit(mockFormEvent, 'full', false, true, false));
    //         }

    //         if (Object.values(spouseData || {}).some(value => value) &&
    //             !skippedSections.includes("Spouse Details")) {
    //             savePromises.push(handleSpouseSubmit(mockFormEvent, true, false, employeeId));
    //         }

    //         const hasNewChildInput =
    //             childName.trim() !== "" || childDob !== null || childGender.trim() !== "";

    //         if ((children.length > 0 || hasNewChildInput) &&
    //             !skippedSections.includes("Children Details")) {
    //             savePromises.push(handleAddOrUpdateChild(false, employeeId));
    //         }

    //         if (Object.values(parentData || {}).some(v => v) &&
    //             !skippedSections.includes("Parents Details")) {
    //             savePromises.push(handleParentSubmit(mockFormEvent, true, false, employeeId));
    //         }

    //         if (!skippedSections.includes("Additional Information")) {
    //             savePromises.push(handleEmployeeSubmit(mockFormEvent, "additional", false, true, false, employeeId));
    //         }

    //         if (!skippedSections.includes("Employment Details")) {
    //             savePromises.push(handleEmployeeSubmit(mockFormEvent, "employement", false, true, false, employeeId));
    //         }

    //         if (!skippedSections.includes("Job Information")) {
    //             savePromises.push(handleEmployeeSubmit(mockFormEvent, "jobInfo", false, true, false, employeeId));
    //         }

    //         if (!skippedSections.includes("Location Information")) {
    //             savePromises.push(handleEmployeeSubmit(mockFormEvent, "location_info", false, true, false, employeeId));
    //         }

    //         const hasNewExperienceData = Object.values(newExperience || {}).some(val => val);
    //         if ((experiences.length > 0 || hasNewExperienceData) &&
    //             !skippedSections.includes("Work Experience")) {
    //             savePromises.push(handleAddOrUpdateAndSaveExperience(false));
    //         }

    //         if (!skippedSections.includes("Skills")) {
    //             const hasUnsavedSkills =
    //                 (skillName && Number(proficiency) >= 1 && Number(proficiency) <= 10) ||
    //                 skills.some(skill => !skill.id || skill.id === -1);

    //             if (hasUnsavedSkills || skills.length > 0) {
    //                 savePromises.push(handleAddOrUpdateAndSaveSkill(false));
    //             }
    //         }

    //         if (editingSections.education &&
    //             hasQualificationData() &&
    //             !skippedSections.includes("Education")) {
    //             savePromises.push(handleEducationSubmit(mockFormEvent, true, false));
    //         }

    //         if (Object.values(leaveForm || {}).some(v => v) &&
    //             !skippedSections.includes("Leave Information")) {
    //             savePromises.push(handleAddAndSaveLeaves(false));
    //         }

    //         const shouldSaveDocuments =
    //             editingSections.document && hasUnsavedOrDuplicateDocuments();

    //         if (shouldSaveDocuments && !skippedSections.includes("Documents")) {
    //             const docSaved = await handleAddAndSaveDocument(false);
    //             if (!docSaved) {
    //                 setIsSaving(false);
    //                 return false;
    //             }
    //         }

    //         if (!skippedSections.includes("Salary Structure")) {
    //             const hasUnsavedInput =
    //                 Object.values(employeeSalaryData || {}).some(
    //                     val => val !== undefined && val !== null && val !== "" && val !== 0
    //                 ) ||
    //                 (earningsData && earningsData.length > 0) ||
    //                 (deductionsData && deductionsData.length > 0);

    //             if (hasUnsavedInput && salaryStructRef?.current?.handleSubmit) {
    //                 savePromises.push(salaryStructRef.current.handleSubmit(false, false));
    //             }
    //         }

    //         await Promise.all(savePromises);

    //         if (employeeId && !isCreateMode) {
    //             await dispatch(getEmployeeById({ employeeId }));
    //         }

    //         if (onClose) onClose();
    //         return true;

    //     } catch (err: any) {
    //         console.error("Save all sections error:", err);
    //         message.error(err.response?.data?.message || "Failed to save employee data.");
    //         return false;
    //     } finally {
    //         setIsSaving(false);
    //     }
    // };


    // Handle modal close
    const handleCancel = () => {
        setIsModalVisible(false);
        setModalType("");

        dispatch(resetCreatedEmployeeId());

        resetEmployeeForm("all");
        resetSpouseForm();
        resetParentForm();
        resetEducationForm();
        setFormData(initialFormData);
        setProfileImage(null);
        setImagePreview(null);

        // Reset all local component states
        setChildName("");
        setChildDob(null);
        setChildGender("");

        setNewExperience(initialExperienceState);

        setSkillName("");
        setProficiency("");

        // document
        setDocumentType(documentTypes[0]);
        setDocumentNumber("");
        setFile(null);
        setFileName("");
        setFilePreview(null);
        setAdditionalNotes("");
        setAccessDoc('');

        setLeaveForm("");

        setEditingSections({
            basic: false,
            spouse: false,
            children: false,
            parents: false,
            additional: false,
            employment: false,
            job: false,
            location: false,
            experience: false,
            skills: false,
            education: false,
            leave: false,
            document: false
        });
        setEditingSalaryStruct({
            EditsalaryStructure: false
        })
    };

    const { employeeData, handleChange, setEmployeeData, handleEmployeeSubmit, employeeErrors, profileImagePreview, setProfileImagePreview, resetEmployeeForm, validate, planName } = useBasicInfo(setTableKey, handleCancel, showFullDetailsTab, modalType, setShowFullDetailsTab);

    // Helper Function
    const toNumber = (v: any) => {
        const n = Number(v);
        return Number.isFinite(n) ? n : null;
    };

    const normalizeHrIds = (hrId: unknown): number[] => {
        if (!hrId) return [];
        if (Array.isArray(hrId)) {
            return hrId.map(toNumber).filter((n): n is number => n !== null);
        }
        if (typeof hrId === 'string') {
            try {
                const parsed = JSON.parse(hrId);
                return Array.isArray(parsed)
                    ? parsed.map(toNumber).filter((n): n is number => n !== null)
                    : [];
            } catch {
                return [];
            }
        }
        return [];
    };

    const selectedDept = React.useMemo(() => {
        const depId = toNumber(employeeData.department);
        return activeDepartment?.find((d: any) => toNumber(d.Id) === depId);
    }, [activeDepartment, employeeData.department]);

    const allowedHrIdSet = React.useMemo(() => {
        const ids = normalizeHrIds(selectedDept?.hrId);
        return new Set(ids);
    }, [selectedDept]);

    const filteredHR = React.useMemo(() => {
        if (!activeHR) return [];
        if (allowedHrIdSet.size === 0) return [];
        return activeHR.filter((hr: any) => allowedHrIdSet.has(toNumber(hr.EmployeeID)!));
    }, [activeHR, allowedHrIdSet]);

    const handleChangeWrapped = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const { name, value } = e.target;

        if (name === 'department') {
            const nextDepId = toNumber(value);
            const nextDept = activeDepartment?.find((d: any) => toNumber(d.Id) === nextDepId);
            const nextAllowed = new Set(normalizeHrIds(nextDept?.hrId));

            const currentHrId = toNumber(employeeData.hr);
            const nextState: any = { ...employeeData, department: value };
            if (!currentHrId || !nextAllowed.has(currentHrId)) {
                nextState.hr = '';
            }
            handleChange({ ...e, target: { ...e.target, name: 'department', value } } as any);
            // If your handleChange can accept object updates directly, you can instead call setEmployeeData(nextState)
            return;
        }

        handleChange(e);
    };

    const handleEducationFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];
        if (file) {
            handleEducationCSVImport(file);
            e.target.value = "";
        }
    };


    const handleImportFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];
        if (file) {
            handleCSVImport(file);
            e.target.value = "";
        }
    };
    // experience functions
    const [experiences, setExperiences] = useState<Experience[]>([]);
    const [newExperience, setNewExperience] = useState<Experience>({
        companyName: "",
        jobTitle: "",
        startDate: "",
        endDate: "",
        reasonForLeaving: "",
        companyLocation: "",
        salary: "",
        employmentType: "full-time",
        jobDescription: "",
    });
    const [selectedExperienceIndex, setSelectedExperienceIndex] = useState<number | null>(null);
    const [children, setChildren] = useState<Child[]>([]);
    const [childName, setChildName] = useState<string>("");
    const [childDob, setChildDob] = useState<Dayjs | null>(null);
    const [childGender, setChildGender] = useState<string>("");
    const [selectedChildIndex, setSelectedChildIndex] = useState<number | null>(null);

    const [documents, setDocuments] = useState<Document[]>([]);
    const addedTypes = documents.map((doc: Document) => doc.documentType);
    const [documentType, setDocumentType] = useState<string>("aadhar");
    const [documentNumber, setDocumentNumber] = useState<string>("");
    const [file, setFile] = useState<File | null>(null);
    const [additionalNotes, setAdditionalNotes] = useState<string>("");
    const [documentIndex, setDocumentIndex] = useState<number | null>(null);

    const [skills, setSkills] = useState<Skill[]>([]);
    const [skillName, setSkillName] = useState<string>("");
    const [proficiency, setProficiency] = useState<number | string>("");
    const [selectedSkillIndex, setSelectedSkillIndex] = useState<number | null>(null);
    const [upperlevelEmp, setupperlevelEmp] = useState<any>([])

    useEffect(() => {
        if (!roles.length) {
            dispatch(fetchAllRoles());
        }
        if (!skillMaster.length) {
            dispatch(fetchALlSkill());
        }
    }, [dispatch, roles.length, skillMaster.length]);

    useEffect(() => {
        if (selectedRowData?.EmployeeID) {
            dispatch(fetchAllEmployeelogById(selectedRowData?.EmployeeID)).then((res) => {
                setemployeelog(res.payload.data);
            }
            );
        }
    }, [selectedRowData]);

    useEffect(() => {
        dispatch(fetchAllBranch());
        dispatch(FetchAlljobLocation()).then((res) => {
            setjoblocation(res.payload.data);
            dispatch(fetchingexperience())
                .then((res) => {
                    setMapExperience(res.payload.data)
                })
        });
        dispatch(fetchAllLeaveTypes());

    }, [dispatch]);

    // Fetch employees if not loaded
    useEffect(() => {
        if (!employees.length) {
            dispatch(getEmployees());
        }
    }, [employees.length, dispatch]);

    useEffect(() => {
        if (selectedRowData?.EmployeeID) {
            dispatch(getUppderLevelById({ employeeId: selectedRowData?.EmployeeID }))
                .then((res) => {
                    setupperlevelEmp(res.payload.data)
                })
        }
    }, [dispatch, selectedRowData, modalType === "edit"])

    // Fetch analytics if not loaded
    useEffect(() => {
        if (!EmployeeAnalytics?.total_employees) {
            dispatch(fetchEmployeeAnalytics());
        }
    }, [EmployeeAnalytics?.total_employees, dispatch]);

    // Fetch employee by ID when a row is selected

    useEffect(() => {
        if (modalType === "edit" || modalType === "create") {
            dispatch(fetchAllDepartments());
            dispatch(fetchAllDesignations());
        }
    }, [dispatch, modalType]);

    const handleEditEmployee = (record: any): void => {
        if (record.EmployeeID === selectedRowData?.EmployeeID) {
            setSelectedRowData(null);
            setTimeout(() => setSelectedRowData(record), 0);
        } else {
            setSelectedRowData(record);
        }
    };


    const showModal = (type: "edit" | "create") => {
        setModalType(type);
        setIsModalVisible(true);
        resetSpouseForm();
        resetParentForm();
        resetEducationForm();

        if (type === "create") {
            setSelectedRowData(null);
            setShowFullDetailsTab(false);
            setActiveTab('personal')
        } else if (type === 'edit') {
            setShowFullDetailsTab(true);
        }
        setTimeout(() => {
            basicInfoTabRef.current?.click();
            if (tabContentRef.current) {
                const panes = tabContentRef.current.querySelectorAll(".tab-pane");
                panes.forEach(pane => {
                    pane.classList.remove("show", "active");
                });

                const basicPane = tabContentRef.current.querySelector("#basic-info");
                basicPane?.classList.add("show", "active");
            }
        }, 0);
    };

    // documents functions
    const [docNumberError, setDocNumberError] = useState("");
    const [fileError, setFileError] = useState("");

    const patterns: Record<string, RegExp> = {
        aadhar: /^\d{12}$/,
        pan: /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
        "driving-license": /^[A-Z]{2}\d{2}\s?\d{11,13}$/,
        passport: /^[A-PR-WYa-pr-wy][0-9]{7}$/,
        "voter-id": /^[A-Z]{3}[0-9]{7}$/,
        "ghana-card": /^GHA-\d{9}[A-Z]$/
    };

    const handleAddAndSaveDocument = async (showMessage: boolean = true): Promise<boolean> => {
        if (!documentNumber || !fileName) {
            message.warning("Please fill all fields to add/update a document.");
            return false;
        }
        if (additionalNotes.length > 499) {
            message.warning("Additional notes should be less than 499 characters.")
            return false
        };
        if (!file && !fileName) {
            setFileError("Please upload a file before saving.");
            return false;
        } else {
            setFileError("");
        }
        if (!documentNumber) {
            setDocNumberError("Document number is required");
            return false;
        } else if (patterns[documentType] && !patterns[documentType].test(documentNumber)) {
            setDocNumberError(`Invalid ${documentType} format`);
            return false;
        } else {
            setDocNumberError("");
        }

        if (documentType !== 'other') {
            const isDuplicate = documents.some(
                (doc, index) => doc.documentType === documentType && index !== documentIndex
            );
            if (isDuplicate) {
                message.warning(`A document with type "${documentType}" already exists.`);
                return false;
            }
        }
        const newDocument: Document = {
            id: documentIndex !== null ? documents[documentIndex]?.id || -1 : -1,
            documentType,
            Name: documentType,
            documentNumber,
            file,
            additionalNotes,
            accessDoc,
        };

        let updatedDocuments: Document[];
        if (documentIndex !== null) {
            updatedDocuments = documents.map((doc, index) =>
                index === documentIndex ? newDocument : doc
            );
        } else {
            updatedDocuments = [newDocument, ...documents];
        }
        setDocuments(updatedDocuments);

        // FormData
        const formData = new FormData();
        formData.append("Name", documentType);
        formData.append("Description", additionalNotes || "");
        formData.append("DocumentNumber", documentNumber || "");
        formData.append("access", accessDoc);

        const isNewDoc = !newDocument.id || newDocument.id === -1;
        if (isNewDoc) formData.append("CreatedBy", user?.UserId);
        if (modalType === "edit") formData.append("ModifiedBy", user?.UserId);
        if (file) formData.append("file", file);

        const employeeId = selectedRowData?.EmployeeID || createdEmployeeId || employee?.EmployeeId;
        if (!employeeId) {
            message.error("Employee ID is missing!");
            return false;
        }

        try {
            let finalUpdatedDocs: Document[] = [];

            if (modalType === "edit" && !isNewDoc) {
                await dispatch(updateEmployeeDocument({ Id: newDocument.id, documentData: formData })).unwrap();

                finalUpdatedDocs = documents.map((doc, index) =>
                    index === documentIndex ? { ...newDocument } : doc
                );
            } else {
                const res = await dispatch(createEmployeeDocument({ employeeId, documentData: formData })).unwrap();
                const savedDoc = { ...newDocument, id: res?.Id };
                finalUpdatedDocs = [savedDoc, ...documents];
            }

            setDocuments(finalUpdatedDocs);
            if (showMessage) message.success(isNewDoc ? "Document saved successfully!" : "Document updated successfully!");
            await dispatch(getEmployeeById({ employeeId }));

            setDocumentType("aadhar");
            setDocumentNumber("");
            setFile(null);
            setFileName("");
            setFilePreview("");
            setAdditionalNotes("");
            setDocumentIndex(null);

            if (fileInputRef.current) fileInputRef.current.value = "";
            return true;
        } catch (error: any) {
            console.error("Document save error:", error);
            message.warning(typeof error === "string" ? error : "Failed to save or update document.");
            return false;
        }
    };

    const [filePreview, setFilePreview] = useState<string | null>(null);
    const [fileName, setFileName] = useState<string | null>(null);

    const handleEditDocument = (index: number): void => {
        const documentToEdit = documents[index];

        // Map backend document type to your dropdown values
        const typeMap: Record<string, string> = {
            "aadhar": "aadhar",
            "pan": "pan",
            "driving-license": "driving-license",
            "passport": "passport",
            "voter-id": "voter-id",
            "ghana-card": "ghana-card",
            "highschool": "highschool",
            "senior-secondary": "senior-secondary",
            "graduation": "graduation",
            "post-graduation": "post-graduation",
            "other": "other"
        };

        const docType = documentToEdit.Name
            ? typeMap[documentToEdit.Name.toLowerCase().replace(" ", "-")] || "other"
            : documentToEdit.documentType || "other";

        setDocumentType(docType);
        setDocumentNumber(documentToEdit.documentNumber);
        setAdditionalNotes(documentToEdit.additionalNotes || "");
        setDocumentIndex(index);
        setAccessDoc(documentToEdit.accessDoc || "");

        if ((documentToEdit as any).imagePath) {
            setFile(null);
            setFilePreview((documentToEdit as any).imagePath);

            const backendFileName = (documentToEdit as any).imagePath.split("/").pop();
            setFileName(backendFileName || "");

        } else {
            setFilePreview("");
            setFileName("");
        }
    };


    const handleDeleteDocument = async (index: number) => {
        try {
            const documentToDelete = documents[index];
            const employeeId = employee?.EmployeeId || employeeFullDetails?.employee?.[0]?.EmployeeID;

            if (!documentToDelete?.id || !employeeId) {
                message.warning("Invalid document or employee ID");
                return;
            }

            const res = await dispatch(
                deleteEmployeeDocument({ Id: documentToDelete.id, employeeId })
            ).unwrap();

            message.success(res?.message || "Document deleted successfully");

            // Update state
            setDocuments((prev) => prev.filter((_, i) => i !== index));
            if (selectedDocumentIndex === index) setSelectedDocumentIndex(null);
        } catch (error: any) {
            message.error(
                error?.message || "Failed to delete document. Please try again."
            );
        }
    };


    // leave functions

    useEffect(() => {
        if (employeeFullDetails?.employeeleave) {
            setLeaves(employeeFullDetails.employeeleave);
        }
    }, [employeeFullDetails]);

    const handleEditLeave = (index: number) => {
        const leaveToEdit = leaves[index];
        setLeaveForm({ ...leaveToEdit, ApplicableFrom: leaveToEdit.ApplicableFrom ? dayjs(leaveToEdit.ApplicableFrom) : null });
        setSelectedLeaveIndex(index);
    };


    const handleDeleteLeave = async (index: number) => {
        const leaveToDelete = leaves[index];
        if (leaveToDelete?.Id) {//!leaveToDelete?.Id    
            try {

                dispatch(deleteemployeeleave({ Id: leaveToDelete.LeaveType, employeeId: leaveToDelete.EmployeeId }))
                    .then((res) => {
                        message.success(res.payload.data)
                    })

            } catch (error) {
                message.error("Failed to delete");
                return;
            }
        }
        setLeaves((prev) => prev.filter((_, i) => i !== index));
        if (selectedLeaveIndex === index) setSelectedLeaveIndex(null);
    };

    const handleAddAndSaveLeaves = async (showMessage: boolean = true): Promise<boolean> => {
        const { LeaveType, NumberOfDays, ApplicableFrom } = leaveForm;

        // Validate form
        if (!LeaveType || !NumberOfDays || !ApplicableFrom) {
            if (showMessage) {
                message.warning("Please fill all fields to add/update leave.");
            }
            return false;
        }

        const employeeId =
            createdEmployeeId || employee?.EmployeeId || employee?.EmployeeID || employeeFullDetails?.employee?.[0]?.EmployeeID;

        try {
            let updatedLeaves = [...leaves];

            if (selectedLeaveIndex !== null) {
                const leaveData: any = {
                    Id: leaveForm.Id || null,
                    EmployeeId: employeeId,
                    LeaveType: +leaveForm.LeaveType,
                    NumberOfDays: +leaveForm.NumberOfDays,
                    ApplicableFrom: leaveForm.ApplicableFrom ? dayjs(leaveForm.ApplicableFrom).format("YYYY-MM-DD") : null,
                    CreatedBy: leaveForm.CreatedBy || user?.UserId || null,
                    ModifiedBy: leaveForm.ModifiedBy || null,
                    CreatedAt: leaveForm.CreatedAt || null,
                    ModifiedAt: leaveForm.ModifiedAt || null,
                    LeaveTypeName: leaveForm.LeaveTypeName || "",
                    OpeningBalance: leaveForm.OpeningBalance
                };
                if (leaveData?.Id) {
                    await dispatch(updateemployeeleave({ data: leaveData, Id: leaveData.Id })).unwrap();
                    updatedLeaves[selectedLeaveIndex] = leaveData;
                } else {
                    const res = await dispatch(createemployeeleave(leaveData)).unwrap();
                    updatedLeaves[selectedLeaveIndex] = { ...leaveData, Id: res?.Id };
                }
                setSelectedLeaveIndex(null);
            } else {
                const newLeave = { ...leaveForm, EmployeeId: employeeId, ApplicableFrom: leaveForm.ApplicableFrom ? dayjs(leaveForm.ApplicableFrom).format("YYYY-MM-DD") : null, };
                const res = await dispatch(createemployeeleave(newLeave)).unwrap();
                updatedLeaves = [...updatedLeaves, { ...newLeave, Id: res?.Id }];
            }

            setLeaves(updatedLeaves);

            if (employeeId) {
                await dispatch(getEmployeeById({ employeeId }));
            }

            setLeaveForm({
                Id: null,
                EmployeeId: employeeId,
                LeaveType: "",
                NumberOfDays: "",
                ApplicableFrom: "",
                CreatedBy: null,
                ModifiedBy: null,
                CreatedAt: null,
                ModifiedAt: null,
                LeaveTypeName: "",
            });

            if (showMessage) message.success(modalType === "edit" ? "Leave updated successfully!" : "Leave added successfully!");
            return true;
        } catch (error) {
            console.error(error);
            if (showMessage) message.error("Failed to save leaves.");
            return false;
        }
    };

    // Child functions
    const handleAddOrUpdateChild = async (showMessage = true): Promise<boolean> => {
        if (showMessage) {
            if (!childName || !childDob || !childGender) {
                message.warning("Please fill all fields to add/update a child.");
                return false;
            } else if (children.some((child) => child.name.toLowerCase() === childName.toLowerCase())) {
                message.warning("A child with the same name already exists.");
                return false;
            } else if (RegExp(/[^a-zA-Z]/).test(childName)) {
                message.warning("Child name should only contain letters.");
                return false;
            }
        } else {
            if (!childName || !childDob || !childGender) {
                return true;
            }
        }

        const newChild: Child = {
            id:
                selectedChildIndex !== null
                    ? children[selectedChildIndex]?.id || -1
                    : -1,
            name: childName,
            dob: childDob,
            gender: childGender,
        };

        try {
            const childData = {
                Name: newChild.name,
                DateOfBirth: newChild.dob?.format("YYYY-MM-DD"),
                Gender: newChild.gender,
                CreatedBy: user?.UserId,
                ...(modalType === "edit" && { ModifiedBy: user?.UserId }),
            };

            let response;

            const employeeIdToUse = modalType === "edit" ? selectedRowData?.EmployeeID : createdEmployeeId || employee.EmployeeId;

            if (!newChild.id || newChild.id === -1) {
                // Dispatch getEmployeeById action
                await dispatch(getEmployeeById({ employeeId: employeeIdToUse }));

                response = await dispatch(
                    createChild({
                        employeeId: employeeIdToUse,
                        childData,
                    })
                ).unwrap();
                newChild.id = response.id;
            } else {
                response = await dispatch(
                    updateChild({
                        Id: newChild.id,
                        childData,
                    })
                ).unwrap();
            }

            setChildren((prev) =>
                selectedChildIndex !== null
                    ? prev.map((child, index) =>
                        index === selectedChildIndex ? newChild : child
                    )
                    : [...prev, newChild]
            );

            if (showMessage) {
                message.success(
                    newChild.id && newChild.id !== -1
                        ? "Child updated successfully!"
                        : "Child added successfully!"
                );
            }

            setChildren([]);
            await dispatch(getEmployeeById({ employeeId: selectedRowData?.EmployeeID }));
            // Reset form
            setSelectedChildIndex(null);
            setChildName("");
            setChildDob(null);
            setChildGender("");
            return true;
        } catch (error) {
            console.error(error);
            if (showMessage) message.error("Failed to save or update child. Please try again.");
            return false;
        }
    };

    const handleEditChild = (index: number): void => {
        const child = children[index];
        setChildName(child.name);
        setChildDob(child.dob);
        setChildGender(child.gender);
        setSelectedChildIndex(index);
    };

    const handleDeleteChild = async (index: number) => {
        const childToDelete = children[index];

        if (childToDelete?.id) {
            try {
                const res = await dispatch(
                    deleteEmployeeChild({ Id: childToDelete.id, employeeId: selectedRowData?.EmployeeID })
                ).unwrap();
                message.success(res?.message || "Child deleted successfully");

            } catch (error: any) {
                message.error(error?.message || "Failed to delete child");
            }
        }
        setChildren(prev => prev.filter((_, i) => i !== index));
        if (selectedChildIndex === index) setSelectedChildIndex(null);
    };

    // Experience function

    const handleAddOrUpdateAndSaveExperience = async (showMessage = true): Promise<boolean> => {
        const { startDate, endDate } = newExperience;

        // Validate required fields
        if (showMessage) {
            if (
                !newExperience.companyName ||
                !newExperience.jobTitle ||
                !newExperience.startDate ||
                !newExperience.endDate ||
                !newExperience.reasonForLeaving ||
                !newExperience.companyLocation ||
                !newExperience.salary
            ) {
                message.warning("Please fill all fields to add/update an experience.");
                return false;
            }

            if (new Date(startDate) > new Date(endDate)) {
                message.warning("Start date cannot be after end date.");
                return false;
            }
        } else {
            const hasExperienceData = Object.values(newExperience || {}).some(val => val);
            if (!hasExperienceData) return true;
            if (
                !newExperience.companyName ||
                !newExperience.jobTitle ||
                !newExperience.startDate ||
                !newExperience.endDate ||
                !newExperience.reasonForLeaving ||
                !newExperience.companyLocation ||
                !newExperience.salary
            ) {
                return true; // incomplete data → skip instead of failing
            }
        }

        // Prepare payload for API
        const experienceData = {
            CompanyName: newExperience.companyName,
            JobTitle: newExperience.jobTitle,
            StartDate: dayjs(newExperience.startDate).format("YYYY-MM-DD"),
            EndDate: dayjs(newExperience.endDate).format("YYYY-MM-DD"),
            ReasonForLeaving: newExperience.reasonForLeaving,
            CompanyLocation: newExperience.companyLocation,
            Salary: newExperience.salary,
            EmploymentType: newExperience.employmentType,
            JobDescription: newExperience.jobDescription,
            CreatedBy: user?.UserId,
            ModifiedBy: user?.UserId,
        };

        try {
            // Determine the correct employee ID based on mode
            const targetEmployeeId = modalType === "edit"
                ? selectedRowData?.EmployeeID
                : createdEmployeeId || employee?.EmployeeId || employee?.EmployeeID;

            if (!targetEmployeeId) {
                message.error("Please create employee before adding experience.");
                return false;
            }

            let apiResponse;

            if (selectedExperienceIndex !== null) {
                // Editing existing experience
                const existingExperience = experiences[selectedExperienceIndex];
                experienceData.ModifiedBy = user?.UserId;

                if (existingExperience.id && existingExperience.id !== -1) {
                    // Update existing
                    apiResponse = await dispatch(
                        updateExperience({
                            Id: existingExperience.id,
                            experienceData,
                        })
                    ).unwrap();
                } else {
                    // Create new for edit mode
                    apiResponse = await dispatch(
                        createExperience({
                            employeeId: targetEmployeeId,
                            experienceData,
                        })
                    ).unwrap();
                }
            } else {
                // Pure create mode
                apiResponse = await dispatch(
                    createExperience({
                        employeeId: targetEmployeeId,
                        experienceData,
                    })
                ).unwrap();
            }

            // Update local state
            const updatedExperience = {
                ...newExperience,
                id: apiResponse?.id || apiResponse?.data?.id || -1,
            };

            setExperiences(prev =>
                selectedExperienceIndex !== null
                    ? prev.map((exp, idx) =>
                        idx === selectedExperienceIndex ? updatedExperience : exp
                    )
                    : [...prev, updatedExperience]
            );

            // Reset form
            setNewExperience({
                companyName: "",
                jobTitle: "",
                startDate: "",
                endDate: "",
                reasonForLeaving: "",
                companyLocation: "",
                salary: "",
                employmentType: "full-time",
                jobDescription: "",
            });
            setSelectedExperienceIndex(null);

            // Refresh employee data
            dispatch(getEmployeeById({ employeeId: targetEmployeeId }));

            if (showMessage) message.success("Experience saved successfully!");
            return true;
        } catch (error) {
            console.error("Experience save error:", error);
            return false;
        }
    };

    const handleEditExperience = (index: number) => {
        const exp = experiences[index];
        setSelectedExperienceIndex(index);
        setNewExperience({
            ...exp,
            startDate: dayjs(exp.startDate).format("YYYY-MM-DD"),
            endDate: dayjs(exp.endDate).format("YYYY-MM-DD")
        });
    };

    const handleDeleteExperience = async (index: number) => {

        const experienceToDelete = experiences[index];
        const employeeId = employee?.EmployeeId || employeeFullDetails?.employee?.[0]?.EmployeeID;
        if (experienceToDelete?.id) {
            try {
                dispatch(
                    deleteEmployeeExperience({ Id: experienceToDelete.id, employeeId })
                ).then((res) => {
                    message.success(res?.payload.message || res?.payload.data || "Experience deleted successfully");
                });
            } catch (error) {
                message.error("Failed to delete");
                return;
            }
        }
        setExperiences((prev) => prev.filter((_, i) => i !== index));
        if (selectedExperienceIndex === index) setSelectedExperienceIndex(null);
    };

    // Skills function

    const handleSelectSkill = (index: number) => {
        const skill = skills[index];
        setSkillName(skill.name);
        setProficiency(skill.proficiency);
        setSelectedSkillIndex(index);
    };

    const handleAddOrUpdateAndSaveSkill = async (showMessage: boolean = true): Promise<boolean> => {
        const proficiencyNumber = Number(proficiency);

        // Validate inputs
        if (skillName && proficiencyNumber >= 1 && proficiencyNumber <= 10) {
            const skillNameLower = skillName.trim().toLowerCase();

            const isDuplicate = skills.some((skill, index) =>
                skill.name.trim().toLowerCase() === skillNameLower && index !== selectedSkillIndex
            );

            if (isDuplicate) {
                message.warning("This skill already exists.");
                return false;
            }

            const newSkill: Skill = {
                id: selectedSkillIndex !== null ? skills[selectedSkillIndex]?.id || -1 : -1,
                name: skillName,
                proficiency: proficiencyNumber,
            };

            // Add or update locally
            let updatedSkills: Skill[] = [];
            if (selectedSkillIndex !== null) {
                updatedSkills = skills.map((skill, index) =>
                    index === selectedSkillIndex ? newSkill : skill
                );
            } else {
                updatedSkills = [newSkill, ...skills];
            }

            // Reset inputs
            setSkillName("");
            setProficiency("");
            setSelectedSkillIndex(null);

            try {
                const promises = updatedSkills.map(async (skill) => {
                    const skillData: any = {
                        SkillName: skill.name,
                        ProficiencyScore: skill.proficiency,
                        CreatedBy: user?.UserId,
                    };

                    const isNewSkill = !skill.id || skill.id === -1;

                    // For both create and edit modes
                    if (isNewSkill) {
                        try {
                            const targetEmployeeId = modalType === "edit"
                                ? selectedRowData?.EmployeeID
                                : createdEmployeeId || employee?.EmployeeId || employee?.EmployeeID;

                            if (!targetEmployeeId) {
                                message.error("No employee ID available");
                            }

                            return await dispatch(
                                createTopSkill({
                                    employeeId: targetEmployeeId,
                                    topSkillData: skillData,
                                })
                            ).unwrap();
                        } catch (err: any) {
                            if (typeof err === "string" && err.includes("already exists")) {
                                if (showMessage) message.warning(err);
                                throw new Error("DuplicateSkill");
                            }
                            throw err;
                        }
                    } else {
                        // Existing skill - update
                        skillData.ModifiedBy = user?.UserId;
                        return await dispatch(
                            updateTopSkill({
                                Id: skill.id,
                                topSkillData: skillData,
                            })
                        ).unwrap();
                    }
                });

                setSkills([]);
                const results = await Promise.all(promises);

                const updatedSkillsWithIds = updatedSkills.map((skill, index) => ({
                    ...skill,
                    id: results[index]?.Id ?? results[index]?.id ?? skill.id,
                }));

                setSkills(updatedSkillsWithIds);

                // Refresh employee data
                const targetEmployeeId = modalType === "edit"
                    ? selectedRowData?.EmployeeID
                    : createdEmployeeId || employee?.EmployeeId || employee?.EmployeeID;

                if (targetEmployeeId) {
                    dispatch(getEmployeeById({ employeeId: targetEmployeeId }));
                }

                if (showMessage) message.success("Skills saved successfully!");
                return true;
            } catch (error: any) {
                if (error.message === "DuplicateSkill") {
                    return false;
                }
                console.error("Skill save error:", error);
                if (showMessage) message.error("Failed to save or update skills. Please try again.");
                return false;
            }
        } else {
            if (showMessage) message.warning("Please enter a valid skill name and proficiency (1–10).");
            return false;
        }
    };

    useEffect(() => {
        if (selectedRowData) {
            dispatch(getEmployeeById({ employeeId: selectedRowData?.EmployeeID }));
        }
    }, [selectedRowData, dispatch]);

    useEffect(() => {
        if (employeeFullDetails?.skills) {
            const formattedSkills = employeeFullDetails.skills.map((skill: any) => ({
                id: skill.Id,
                name: skill.SkillName,
                proficiency: skill.ProficiencyScore,
            }));
            setSkills(formattedSkills);
        }

        if (employeeFullDetails?.children) {
            const formattedChildren = employeeFullDetails.children.map(
                (child: any) => ({
                    id: child.Id,
                    name: child.Name,
                    dob: dayjs(child.DateOfBirth),
                    gender: child.Gender,
                })
            );
            setChildren(formattedChildren);
        }
        if (employeeFullDetails?.documents) {
            const formattedDocuments = employeeFullDetails.documents.map((doc: any) => {
                const rawType = doc.DocumentType ?? doc.Name ?? "";
                const normalizedType = String(rawType).toLowerCase().replace(/\s+/g, "-");

                return {
                    id: doc.Id,
                    Name: doc.Name ?? rawType ?? "",
                    documentType: normalizedType,
                    documentNumber: doc.DocumentNumber ?? "",
                    additionalNotes: doc.Notes ?? doc.Description ?? "",
                    file: null,
                    imagePath: doc.image_path ?? doc.Picture ?? "",
                    accessDoc: doc.access ?? '',
                };
            });
            setDocuments(formattedDocuments);
        }
        if (employeeFullDetails?.experience) {
            const formattedExperiences = employeeFullDetails.experience.map(
                (exp: any) => ({
                    id: exp.Id,
                    companyName: exp.CompanyName,
                    jobTitle: exp.JobTitle,
                    startDate: exp.StartDate,
                    endDate: exp.EndDate,
                    reasonForLeaving: exp.ReasonForLeaving,
                    companyLocation: exp.CompanyLocation,
                    salary: exp.Salary,
                    employmentType: exp.EmploymentType,
                    jobDescription: exp.JobDescription,
                })
            );
            setExperiences(formattedExperiences);
        }
    }, [employeeFullDetails]);

    const headerCellStyle = {
        padding: "8px 10px",
        backgroundColor: "#fafafa",
        fontWeight: 600,
        color: "#333",
        borderBottom: "1px solid #ccc",
    };

    const cellStyle = {
        padding: "8px 10px",
        borderBottom: "1px solid #eee",
        fontSize: "14px",
    };

    const rowHoverStyle = {
        transition: "background-color 0.2s",
        cursor: "default",
        ":hover": {
            backgroundColor: "#f5f5f5",
        },
    };

    const handleDeleteSkill = async (index: number) => {
        const skillToDelete = skills[index];
        const employeeId = employee?.EmployeeId || employeeFullDetails?.employee?.[0]?.EmployeeID;

        if (!skillToDelete?.id || !employeeId) return;

        try {
            const res = await dispatch(
                deleteEmployeeSkill({ Id: skillToDelete.id, employeeId })
            ).unwrap();

            message.success(res.message || "Skill deleted successfully");
            setSkills((prev) => prev.filter((_, i) => i !== index));
            if (selectedSkillIndex === index) setSelectedSkillIndex(null);
        } catch (error: any) {
            message.error(error?.message || "Failed to delete skill");
        }
    };

    const handleDeleteEmployee = async (employeeId: number) => {
        try {
            const result = await dispatch(deleteEmployee({ employeeId }));
            if (result.meta.requestStatus === "fulfilled") {
                message.success("Employee deleted successfully");
                await dispatch(getEmployees());
                setTableKey((prevKey) => prevKey + 1);
                setIsDeleteModalVisible(false);
            } else {
                alert(result.payload.error);
            }
        } catch (error) {
            message.error("Something went wrong");
        }
    };

    const data = employees;

    const downloadSampleFormat = [
        {
            FirstName: "ASARE",
            LastName: "KONADU PRISCILLA",
            Email: "k.asarepriscilla@gmail.com",
            Password: "Password123",
            DateOfBirth: "6/3/1998",
            Gender: "Male",
            Designation: "HR",
            Department: "Engineering",
            JoiningDate: "8/1/2022",
            PhoneNumber: "2046298812",
            About: "Hardworking and reliable",
            ReportingManager: "Sushant Sharma",
            Hr: "Aman Sharma",
            hod: "Sanyog K",
            Company: "HR Software",
            EmployeeRole: "Admin",
            EmploymentType: "Full-time",
            WorkPreference: "Client-side",
            Employee_status: "Active",
            PfEnable: "1",
            Branch: "Noida",
            Job_location: "Noida",
            BankAccountForPayroll: "12345678",
            BankIfscForPayroll: "SBIN0001234",
            BankNameForPayroll: "State Bank of India",
            BankBranchAddress: "MG Road, Delhi",
            Experiencelabel: "Fresher"
        }
    ];

    const EmployeeListData = data?.map((item: any) => ({
        // employeeId: item.EmployeeID,
        EmployeeCode: item.EmployeeNumber,
        name: item.Name,
        email: item.email,
        Phone: item.Phone,
        DateOfBirth: item.DateOfBirth ? dayjs(item.DateOfBirth).format("YYYY-MM-DD") : null,
        GenderId: item.GenderId === 1 ? "Male" : "Female",
        DateOfJoining: item.DateOfJoining ? dayjs(item.DateOfJoining).format("YYYY-MM-DD") : null,
        // DesignationId: item.DesignationId,
        company: item.Company,
        employee_status: item.employee_status === "active" ? "Active" : "Inactive",
        WorkPreference: item.WorkPreference,
        EmploymentType: item.EmploymentType === "full-time" ? "Full-time" : "Part-time",
        // pfEnable: item.pfEnable === 1 ? "Yes" : "No",
        job_location: item.job_location,
        role_name: item.role_name,
        designation_name: item.designation_name ? item.designation_name : "N/A",
        department_name: item.department_name ? item.department_name : "N/A",
        // description: item.Description,
    }))

    const filteredData = useMemo(() => {
        return filterData(
            data || [],
            { employee_status: selectedStatus },
            "CreatedAt",
            "CreatedAt",
            selectedSort
        );
    }, [data, selectedStatus, selectedSort]);

    useEffect(() => {
        setTableKey((prevKey) => prevKey + 1);
    }, [selectedStatus, selectedSort, employees]);


    const baseColumns = [
        {
            title: "Emp ID",
            dataIndex: "EmployeeNumber",
            render: (text: String, record: any) => (
                <Link
                    to={all_routes.employeedetails.replace(
                        ":employeeId",
                        btoa(record.EmployeeID.toString())
                    )}
                >
                    {text}
                </Link>
            ),
            sorter: (a: any, b: any) =>
                a.EmployeeNumber.length - b.EmployeeNumber.length,
        },
        {
            title: "Name",
            dataIndex: "Name",
            render: (text: string, record: any) => (
                <div className="d-flex align-items-center employee-card p-1 justify-content-between">
                    <div className="d-flex align-items-center">
                        <Link to={`${all_routes.employeedetails.replace(
                            ":employeeId",
                            btoa(record.EmployeeID.toString())
                        )}`}
                            className="avatar avatar-md">
                            <img src={record.PictureURL ?? "https://cdn-icons-png.flaticon.com/512/149/149071.png"}
                                alt="img"
                                className="img-fluid rounded-circle"
                            />
                        </Link>
                        <div className="ms-2">
                            <p className="text-dark mb-0">
                                <Link
                                    to={`${all_routes.employeedetails.replace(
                                        ":employeeId",
                                        btoa(record.EmployeeID.toString())
                                    )}`}
                                >
                                    {record.Name}
                                </Link>
                            </p>
                            <span className="fs-12">{record.CurrentRole}</span>
                        </div>

                    </div>

                    <button className="edit-btn btn btn-link p-0"
                        disabled={!canEdit}
                        onClick={() => {
                            if (!canEdit) return;
                            showModal("edit");
                            setShowFullDetailsTab(true);
                            handleEditEmployee(record);
                        }}
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        title="Edit"
                    >
                        <i className="ti ti-pencil fs-15" />
                    </button>
                </div>
            ),
            sorter: (a: any, b: any) => a.Name.length - b.Name.length,
        },
        {
            title: "Email",
            dataIndex: "email",
            sorter: (a: any, b: any) => a.email.length - b.email.length,
        },
        {
            title: "Phone",
            dataIndex: "Phone",
            sorter: (a: any, b: any) => a.Phone.length - b.Phone.length,
        },
        {
            title: "Designation",
            dataIndex: "designation_name",
            sorter: (a: any, b: any) => a.email.length - b.email.length,
        },
        {
            title: "Department",
            dataIndex: "department_name",
            sorter: (a: any, b: any) =>
                a.department_name.length - b.department_name.length,
        },
        {
            title: "Role",
            dataIndex: "role_name",
            sorter: (a: any, b: any) => a.role_name.length - b.role_name.length,
        },
        {
            title: "Manager Name",
            dataIndex: "supervisor_name",
            sorter: (a: any, b: any) => a.supervisor_name.length - b.supervisor_name.length,
        },
        {
            title: "Joining Date",
            dataIndex: "DateOfJoining",
            render: (text: string) => {
                if (!text) return "NA";
                return formatDate(text, config);
            },
            sorter: (a: any, b: any) => {
                const dateA = new Date(a.DateOfJoining);
                const dateB = new Date(b.DateOfJoining);
                return dateA.getTime() - dateB.getTime();
            },
        },
        {
            title: "Status",
            dataIndex: "employee_status",
            render: (text: string, record: any) => (
                <span
                    className={`badge ${text === "active" ? "badge-success" : "badge-danger"
                        } d-inline-flex align-items-center badge-xs`}
                >
                    <i className="ti ti-point-filled me-1" />
                    {text ? text.charAt(0).toUpperCase() + text.slice(1) : ""}

                </span>
            ),
            sorter: (a: any, b: any) =>
                a.employee_status.length - b.employee_status.length,
        },
        {
            title: "Action",
            dataIndex: "actions",
            render: (text: string, record: any) => (
                <div className="action-icon d-inline-flex">
                    <button
                        className="me-2"
                        disabled={!canEdit}
                        onClick={() => {
                            if (!canEdit) return;
                            showModal("edit");
                            setShowFullDetailsTab(true);
                            handleEditEmployee(record);
                        }}
                        style={{
                            cursor: canEdit ? "pointer" : "not-allowed",
                            opacity: canEdit ? 1 : 0.5,
                        }}
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        title="Edit"
                    >
                        <i className="ti ti-edit" />
                    </button>

                    <button
                        className="me-2"
                        disabled={!canDelete || record.employee_status === "inactive"}
                        onClick={() => {
                            if (!canDelete || record.employee_status === "inactive") return;
                            setSelectedRowData(record);
                            setIsDeleteModalVisible(true);
                        }}
                        style={{
                            cursor:
                                !canDelete || record.employee_status === "inactive"
                                    ? "not-allowed"
                                    : "pointer",
                            opacity:
                                !canDelete || record.employee_status === "inactive" ? 0.5 : 1,
                        }}
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        title="Delete"
                    >
                        <i className="ti ti-trash" />
                    </button>

                    <button
                        disabled={!canView}
                        onClick={() => {
                            if (!canView) return;
                            setViewModalOpen(true);
                            setSelectedRowData(record);
                        }}
                        style={{
                            cursor: canView ? "pointer" : "not-allowed",
                            opacity: canView ? 1 : 0.5,
                        }} data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        title="Employee log"
                    >
                        <i className="ti ti-clock" />
                    </button>
                </div>
            ),
        },
    ];

    const columns = useMemo(() => {
        const plan = (planName || '').toString().toLowerCase();
        if (plan === 'basic') {
            return baseColumns.filter(col => col.dataIndex !== 'email');
        }
        return baseColumns;
    }, [baseColumns]);

    return (
        <>
            {/* Page Wrapper */}
            <div className="page-wrapper">
                <div className="content">
                    {/* Breadcrumb */}
                    <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
                        <div className="my-auto mb-2">
                            <h2 className="mb-1">Employee</h2>
                            <nav>
                                <ol className="breadcrumb mb-0">
                                    <li className="breadcrumb-item">
                                        <Link to={all_routes.adminDashboard}>
                                            <i className="ti ti-smart-home" />
                                        </Link>
                                    </li>
                                    <li className="breadcrumb-item">Employee</li>
                                    <li className="breadcrumb-item active" aria-current="page">
                                        Employee List
                                    </li>
                                </ol>
                            </nav>
                        </div>
                        <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
                            {/* <div className="me-2 mb-2">
                                <div className="d-flex align-items-center border bg-white rounded p-1 me-2 icon-list">
                                    <Link
                                        to={all_routes.employeeList}
                                        className="btn btn-icon btn-sm active bg-primary text-white me-1"
                                    >
                                        <i className="ti ti-list-tree" />
                                    </Link>
                                </div>
                            </div> */}
                            <div className="me-2 mb-2">
                                {canExport && (
                                    <div className="dropdown">
                                        <button
                                            className="dropdown-toggle btn btn-white d-inline-flex align-items-center me-2"
                                            data-bs-toggle="dropdown"
                                            data-bs-placement="top"
                                            title="Export"
                                        >
                                            <i className="ti ti-file-export me-1" />
                                            Export
                                        </button>

                                        <ul className="dropdown-menu dropdown-menu-end p-3">
                                            <li>
                                                <button
                                                    onClick={() => exportToCSV(EmployeeListData, "employee_data")}
                                                    className="dropdown-item rounded-1"
                                                >
                                                    <i className="ti ti-file-type-csv me-1" />
                                                    Export as CSV
                                                </button>
                                            </li>
                                            <li>
                                                <button
                                                    onClick={() => exportToExcel(EmployeeListData, "employee_data")}
                                                    className="dropdown-item rounded-1"
                                                >
                                                    <i className="ti ti-file-type-xls me-1" />
                                                    Export as Excel
                                                </button>
                                            </li>
                                            <li>
                                                <button
                                                    onClick={() => exportToPDF(EmployeeListData, "employee_data")}
                                                    className="dropdown-item rounded-1"
                                                >
                                                    <i className="ti ti-file-type-xls me-1" />
                                                    Export as PDF
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                )}
                            </div>
                            <div className="me-2 mb-2">
                                {canImport && (
                                    <div className="dropdown me-2">
                                        <Link
                                            to="#"
                                            className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                                            data-bs-toggle="dropdown"
                                        >
                                            <i className="ti ti-file-export me-1" />
                                            Import
                                        </Link>

                                        <ul className="dropdown-menu dropdown-menu-end p-3" style={{ minWidth: "250px" }}>

                                            {/* ================= EMPLOYEE ================= */}
                                            <li className="fw-bold px-2 text-muted small">Employee</li>
                                            <li>
                                                <button
                                                    type="button"
                                                    onClick={() => triggerImportFileSelect()}
                                                    className="dropdown-item rounded-1"
                                                >
                                                    <i className="ti ti-file-import me-1" />
                                                    Import as CSV
                                                </button>
                                            </li>
                                            <li>
                                                <button
                                                    type="button"
                                                    onClick={() => setShowSampleModal(true)}
                                                    className="dropdown-item rounded-1"
                                                >
                                                    <i className="ti ti-eye me-1" />
                                                    View Sample Format
                                                </button>
                                            </li>

                                            <li><hr className="dropdown-divider" /></li>


                                            {/* ================= EDUCATION ================= */}
                                            <li className="fw-bold px-2 text-muted small">Education</li>
                                            <li>
                                                <button
                                                    type="button"
                                                    onClick={() => triggerEducationImport()}
                                                    className="dropdown-item rounded-1"
                                                >
                                                    <i className="ti ti-file-spreadsheet me-1" />
                                                    Import as CSV
                                                </button>
                                            </li>
                                            <li>
                                                <button
                                                    type="button"
                                                    onClick={() => setShowSampleModalEducation(true)}
                                                    className="dropdown-item rounded-1"
                                                >
                                                    <i className="ti ti-eye me-1" />
                                                    View Sample Format
                                                </button>
                                            </li>

                                            <li><hr className="dropdown-divider" /></li>


                                            {/* ================= SKILL ================= */}
                                            <li className="fw-bold px-2 text-muted small">Skill</li>
                                            <li>
                                                <button
                                                    type="button"
                                                    onClick={() => triggerImportSkillFileSelect()}
                                                    className="dropdown-item rounded-1"
                                                >
                                                    <i className="ti ti-file-spreadsheet me-1" />
                                                    Import as CSV
                                                </button>
                                            </li>
                                            <li>
                                                <button
                                                    type="button"
                                                    onClick={() => setShowSampleModalSkill(true)}
                                                    className="dropdown-item rounded-1"
                                                >
                                                    <i className="ti ti-eye me-1" />
                                                    View Sample Format
                                                </button>
                                            </li>

                                        </ul>
                                    </div>
                                )}

                                {/* Hidden Inputs */}
                                <input
                                    type="file"
                                    accept=".csv"
                                    style={{ display: "none" }}
                                    ref={employeeFileInputRef}          // Employee import
                                    onChange={handleImportFileChange}
                                />

                                <input
                                    type="file"
                                    accept=".csv"
                                    style={{ display: "none" }}
                                    ref={educationFileInputRef}         // Education import
                                    onChange={handleEducationFileChange}
                                />

                                <input
                                    type="file"
                                    accept=".csv"
                                    style={{ display: "none" }}
                                    ref={skillFileInputRef}             // Skill import
                                    onChange={handleImportSkillFileChange}
                                />

                            </div>

                            <div className="mb-2">
                                {canAdd && (
                                    <button
                                        onClick={() => {
                                            handleCancel();
                                            showModal("create");
                                        }}
                                        className="btn btn-primary d-flex align-items-center"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Add Employee"
                                    >
                                        <i className="ti ti-circle-plus me-2" />
                                        Add Employee
                                    </button>
                                )}
                            </div>
                            <div className="head-icons ms-2">
                                <CollapseHeader />
                            </div>
                        </div>
                    </div>
                    {/* /Breadcrumb */}
                    <div className="row">
                        {/* Total Plans */}
                        <div className="col-lg-3 col-md-6 d-flex">
                            <div className="card flex-fill">
                                <div className="card-body d-flex align-items-center justify-content-between">
                                    <div className="d-flex align-items-center overflow-hidden">
                                        <div>
                                            <span className="avatar avatar-lg bg-dark rounded-circle">
                                                <i className="ti ti-users" />
                                            </span>
                                        </div>
                                        <div className="ms-2 overflow-hidden">
                                            <p className="fs-12 fw-medium mb-1 text-truncate">
                                                Total Employee
                                            </p>
                                            <h4>{EmployeeAnalytics?.total_employees}</h4>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* /Total Plans */}
                        {/* Active Plans */}
                        <div className="col-lg-3 col-md-6 d-flex">
                            <div className="card flex-fill">
                                <div className="card-body d-flex align-items-center justify-content-between">
                                    <div className="d-flex align-items-center overflow-hidden">
                                        <div>
                                            <span className="avatar avatar-lg bg-success rounded-circle">
                                                <i className="ti ti-user-share" />
                                            </span>
                                        </div>
                                        <div className="ms-2 overflow-hidden">
                                            <p className="fs-12 fw-medium mb-1 text-truncate">
                                                Active
                                            </p>
                                            <h4>{EmployeeAnalytics?.active_employees}</h4>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* /Total Plans */}
                        {/* Inactive Plans */}
                        <div className="col-lg-3 col-md-6 d-flex">
                            <div className="card flex-fill">
                                <div className="card-body d-flex align-items-center justify-content-between">
                                    <div className="d-flex align-items-center overflow-hidden">
                                        <div>
                                            <span className="avatar avatar-lg bg-danger rounded-circle">
                                                <i className="ti ti-user-pause" />
                                            </span>
                                        </div>
                                        <div className="ms-2 overflow-hidden">
                                            <p className="fs-12 fw-medium mb-1 text-truncate">
                                                InActive
                                            </p>
                                            <h4>{EmployeeAnalytics?.inactive_employees}</h4>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* /Inactive Companies */}
                        {/* No of Plans  */}
                        <div className="col-lg-3 col-md-6 d-flex">
                            <div className="card flex-fill">
                                <div className="card-body d-flex align-items-center justify-content-between">
                                    <div className="d-flex align-items-center overflow-hidden">
                                        <div>
                                            <span className="avatar avatar-lg bg-info rounded-circle">
                                                <i className="ti ti-user-plus" />
                                            </span>
                                        </div>
                                        <div className="ms-2 overflow-hidden">
                                            <p className="fs-12 fw-medium mb-1 text-truncate">
                                                New Joiners
                                            </p>
                                            <h4>{EmployeeAnalytics?.new_joinees}</h4>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* /No of Plans */}
                    </div>
                    <div className="card">
                        <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                            <h5>Employee List</h5>
                            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                                <div className="dropdown me-3">
                                    <Link
                                        to="#"
                                        className="dropdown-toggle btn btn-sm btn-white d-inline-flex align-items-center"
                                        data-bs-toggle="dropdown"
                                    >
                                        {selectedStatus
                                            ? selectedStatus.charAt(0).toUpperCase() +
                                            selectedStatus.slice(1)
                                            : "Select Status"}
                                    </Link>
                                    <ul className="dropdown-menu  dropdown-menu-end p-3">
                                        <li>
                                            <Link
                                                to="#"
                                                onClick={() => setSelectedStatus("active")}
                                                className="dropdown-item rounded-1"
                                            >
                                                Active
                                            </Link>
                                        </li>
                                        <li>
                                            <Link
                                                to="#"
                                                onClick={() => setSelectedStatus("inactive")}
                                                className="dropdown-item rounded-1"
                                            >
                                                Inactive
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                                <div className="dropdown">
                                    <Link
                                        to="#"
                                        className="dropdown-toggle btn btn-sm btn-white d-inline-flex align-items-center"
                                        data-bs-toggle="dropdown"
                                    >
                                        {selectedSort
                                            ? `Sort By : ${selectedSort}`
                                            : "Sort By : Last 7 Days"}
                                    </Link>
                                    <ul className="dropdown-menu dropdown-menu-end p-3">
                                        <li>
                                            <Link
                                                to="#"
                                                onClick={() => setSelectedSort("Recently Added")}
                                                className="dropdown-item rounded-1"
                                            >
                                                Recently Added
                                            </Link>
                                        </li>
                                        <li>
                                            <Link
                                                to="#"
                                                onClick={() => setSelectedSort("Ascending")}
                                                className="dropdown-item rounded-1"
                                            >
                                                Ascending
                                            </Link>
                                        </li>
                                        <li>
                                            <Link
                                                to="#"
                                                onClick={() => setSelectedSort("Descending")}
                                                className="dropdown-item rounded-1"
                                            >
                                                Descending
                                            </Link>
                                        </li>
                                        <li>
                                            <Link
                                                to="#"
                                                onClick={() => setSelectedSort("Last Month")}
                                                className="dropdown-item rounded-1"
                                            >
                                                Last Month
                                            </Link>
                                        </li>
                                        <li>
                                            <Link
                                                to="#"
                                                onClick={() => setSelectedSort("Last 7 Days")}
                                                className="dropdown-item rounded-1"
                                            >
                                                Last 7 Days
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="card-body p-0">
                            <Table
                                key={tableKey}
                                dataSource={filteredData}
                                columns={columns}
                                Selection={true}
                            />
                        </div>
                    </div>
                </div>
                <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
                    <p className="mb-0">2024 - 2025© hrmtree.</p>
                    <p>
                        Developed By{" "}
                        <Link to="#" className="text-primary">
                            Leadchain Systems
                        </Link>
                    </p>
                </div>
            </div>
            {/* /Page Wrapper */}

            <Modal
                open={showSampleModal}
                onCancel={() => setShowSampleModal(false)}
                footer={null}
                centered
                width={700}
            >
                <div className="position-relative">
                    <div
                        className="position-absolute"
                        style={{ top: -4, right: 27, zIndex: 2 }}
                    >
                        <button
                            className="btn btn-sm btn-primary"
                            onClick={() => exportToCSV(downloadSampleFormat, "employee_data")}
                        >
                            <i className="ti ti-download me-1" />
                            <span className="d-none d-sm-inline">Download Sample CSV</span>
                        </button>
                    </div>
                    <div
                        style={{
                            overflowX: "auto",
                            maxHeight: "60vh",
                            paddingTop: "2rem",
                            paddingBottom: "1rem",
                            paddingLeft: "1rem",
                            paddingRight: "1rem",
                        }}
                    >
                        <table className="table table-bordered">
                            <thead>
                                <tr>
                                    <th>FirstName</th>
                                    <th>LastName</th>
                                    <th>Email</th>
                                    <th>Password</th>
                                    <th>DateOfBirth</th>
                                    <th>Gender</th>
                                    <th>Designation</th>
                                    <th>Department</th>
                                    <th>JoiningDate</th>
                                    <th>PhoneNumber</th>
                                    <th>About</th>
                                    <th>ReportingManager</th>
                                    <th>Hr</th>
                                    <th>HOD</th>
                                    <th>Company</th>
                                    <th>EmployeeRole</th>
                                    <th>EmploymentType</th>
                                    <th>WorkPreference</th>
                                    <th>Employee_status</th>
                                    <th>PfEnable</th>
                                    <th>Branch</th>
                                    <th>Job_location</th>
                                    <th>BankAccountForPayroll</th>
                                    <th>BankIfscForPayroll</th>
                                    <th>BankNameForPayroll</th>
                                    <th>BankBranchAddress</th>
                                    <th>ExperienceLabel</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>ASARE</td>
                                    <td>KONADU PRISCILLA</td>
                                    <td>k.asarepriscilla@gmail.com</td>
                                    <td>Password123</td>
                                    <td>6/3/1998</td>
                                    <td>Male</td>
                                    <td>HR</td>
                                    <td>IT</td>
                                    <td>8/1/2022</td>
                                    <td>2046298812</td>
                                    <td>Hardworking and reliable</td>
                                    <td>Aman</td>
                                    <td>Sharma ji</td>
                                    <td>Sharma ji</td>
                                    <td>HR Software</td>
                                    <td>Admin</td>
                                    <td>Full-time</td>
                                    <td>Client-side</td>
                                    <td>Active</td>
                                    <td>True</td>
                                    <td>India</td>
                                    <td>Noida</td>
                                    <td>12345678</td>
                                    <td>SBIN0001234</td>
                                    <td>State Bank Of India</td>
                                    <td>MG-Road, Delhi</td>
                                    <td>Fresher</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </Modal>

            <Modal
                open={showSampleModalEducation}
                onCancel={() => setShowSampleModalEducation(false)}
                footer={null}
                centered
                width={700}
            >
                <div className="position-relative">
                    <div
                        className="position-absolute"
                        style={{ top: -4, right: 27, zIndex: 2 }}
                    >
                        <button
                            className="btn btn-sm btn-primary"
                            onClick={() =>
                                exportToCSV(downloadSampleEducationFormat, "sample_education")
                            }
                        >
                            <i className="ti ti-download me-1" />
                            <span className="d-none d-sm-inline">Download Sample CSV</span>
                        </button>
                    </div>

                    <div
                        style={{
                            overflowX: "auto",
                            maxHeight: "60vh",
                            paddingTop: "2rem",
                            paddingBottom: "1rem",
                            paddingLeft: "1rem",
                            paddingRight: "1rem",
                        }}
                    >
                        <table className="table table-bordered">
                            <thead>
                                <tr>
                                    <th>Employee</th>
                                    <th>EducationType</th>
                                    <th>Degree</th>
                                    <th>StartYear</th>
                                    <th>EndYear</th>
                                    <th>Percentage</th>
                                    <th>SchoolName</th>
                                </tr>
                            </thead>

                            <tbody>
                                <tr>
                                    <td>Rahul Dev</td>
                                    <td>Bachelor</td>
                                    <td>B.Tech (CSE)</td>
                                    <td>2019</td>
                                    <td>2023</td>
                                    <td>78%</td>
                                    <td>AKTU University</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </Modal>

            <Modal
                open={showSampleModalSkill}
                onCancel={() => setShowSampleModalSkill(false)}
                footer={null}
                centered
                width={600}
            >
                <div className="position-relative">
                    <div
                        className="position-absolute"
                        style={{ top: -4, right: 27, zIndex: 2 }}
                    >
                        <button
                            className="btn btn-sm btn-primary"
                            onClick={() => exportToCSV(sampleSkillCSV, "skill_sample")}
                        >
                            <i className="ti ti-download me-1" />
                            <span className="d-none d-sm-inline">Download Sample CSV</span>
                        </button>
                    </div>

                    <div
                        style={{
                            overflowX: "auto",
                            maxHeight: "60vh",
                            paddingTop: "2rem",
                            paddingBottom: "1rem",
                            paddingLeft: "1rem",
                            paddingRight: "1rem",
                        }}
                    >
                        <table className="table table-bordered">
                            <thead>
                                <tr>
                                    <th>Employee</th>
                                    <th>SkillName</th>
                                    <th>ProficiencyScore</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Aman Dev</td>
                                    <td>Cloud Computing</td>
                                    <td>9</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </Modal>


            {/* Add Employee */}
            <Drawer
                key={isModalVisible ? 'drawer-open' : 'drawer-closed'}
                title={
                    <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        width: '100%'
                    }}>
                        <span style={{ fontSize: 16, fontWeight: 500 }}>
                            {modalType === "edit" ? "Edit Employee Details" : "Add Employee Details"}
                        </span>
                        <div>
                            <Button
                                onClick={handleCancel}
                                style={{ marginRight: 8 }}
                            >
                                Cancel
                            </Button>
                            <Button
                                type="primary"
                                onClick={handleGlobalSave}
                                loading={isSaving}
                            >
                                {isSaving ? "Saving..." : "Save"}
                            </Button>
                        </div>
                    </div>
                }
                placement="right"
                width={1000}
                onClose={handleCancel}
                visible={isModalVisible}
                style={{ marginTop: 50, paddingBottom: 50 }}
                footer={null}
            >

                <form action={all_routes.employeeList}>
                    <div style={{
                        display: 'flex',
                        height: '100vh',
                    }}>

                        <div className="col-md-2">
                            <div
                                style={{
                                    width: "100%",
                                    borderRight: "1px solid #f0f0f0",
                                    display: "flex",
                                    flexDirection: "column",
                                    backgroundColor: "#fff",
                                }}
                            >
                                {/* Profile Upload Section */}
                                <div
                                    style={{
                                        padding: "12px",
                                        borderBottom: "1px solid #f0f0f0",
                                        borderRight: "1px solid #f0f0f0",
                                        textAlign: "center",
                                        width: "89%",
                                        marginRight: "-20px",
                                        backgroundColor: "#fff",
                                    }}
                                >
                                    <div
                                        className="avatar avatar-xl rounded-circle border border-dashed mx-auto mb-2"
                                        style={{
                                            width: 90,
                                            height: 90,
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                        }}
                                    >
                                        {profileImagePreview ? (
                                            <img
                                                src={profileImagePreview}
                                                alt="Profile Preview"
                                                className="avatar-img rounded-circle"
                                                style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                            />
                                        ) : (
                                            <i className="ti ti-photo text-gray-2 fs-16" />
                                        )}
                                    </div>
                                    <h6 style={{ fontSize: 12, marginBottom: 2 }}>Upload Profile</h6>
                                    <p style={{ fontSize: 10, color: "#888" }}>Below 4 MB</p>
                                    <div className="d-flex justify-content-center gap-1">
                                        {!profileImagePreview ? (
                                            <label className="btn btn-sm btn-primary mb-0">
                                                Upload
                                                <input
                                                    type="file"
                                                    ref={fileInputRef}
                                                    className="form-control image-sign d-none"
                                                    name="profilePicture"
                                                    onChange={handleChange}
                                                />
                                            </label>
                                        ) : (
                                            <label className="btn btn-sm btn-warning mb-0">
                                                Edit
                                                <input
                                                    type="file"
                                                    ref={fileInputRef}
                                                    className="form-control image-sign d-none"
                                                    name="profilePicture"
                                                    onChange={handleChange}
                                                />
                                            </label>
                                        )}
                                        <button
                                            type="button"
                                            className="btn btn-light btn-sm"
                                            disabled={!profileImagePreview}
                                            onClick={async () => {
                                                try {
                                                    await deleteEmployeeProfilePic(selectedRowData?.EmployeeID);
                                                    message.success("Profile picture deleted");

                                                    setProfileImagePreview(null);
                                                    setEmployeeData((prevData) => ({
                                                        ...prevData,
                                                        profilePicture: null,
                                                    }));
                                                    if (fileInputRef.current) {
                                                        fileInputRef.current.value = "";
                                                    }
                                                } catch (err) {
                                                    message.error(String(err));
                                                }
                                            }}
                                        >
                                            Delete
                                        </button>
                                    </div>
                                </div>


                                {/* Tabs Navigation */}
                                <div style={{ flex: 1 }}>
                                    <Tabs
                                        activeKey={activeTab}
                                        onChange={handleTabChange}
                                        tabPosition="left"
                                        style={{
                                            fontSize: 13,
                                            height: "100%",
                                        }}
                                        tabBarStyle={{
                                            paddingRight: 29.8,
                                            marginTop: 10,
                                        }}
                                    >
                                        <TabPane tab={<span style={{ userSelect: "none" }}>Personal</span>} key="personal" />
                                        <TabPane tab={<span style={{ userSelect: "none" }}>Employment</span>} key="employment" disabled={!showFullDetailsTab} />
                                        <TabPane tab={<span style={{ userSelect: "none" }}>Skill</span>} key="skills" disabled={!showFullDetailsTab} />
                                        <TabPane tab={<span style={{ userSelect: "none" }}>Education</span>} key="education" disabled={!showFullDetailsTab} />
                                        <TabPane tab={<span style={{ userSelect: "none" }}>Leave</span>} key="leave" disabled={!showFullDetailsTab} />
                                        <TabPane tab={<span style={{ userSelect: "none" }}>Documents</span>} key="documents" disabled={!showFullDetailsTab} />
                                        <TabPane tab={<span style={{ userSelect: "none" }}>Salary Structure</span>} key="salary structure" disabled={!showFullDetailsTab} />
                                    </Tabs>
                                </div>
                            </div>
                        </div>


                        {/* Right Side - Scrollable Form Content */}
                        <div className="col-md-10">
                            <div style={{
                                flex: 1,
                                overflowY: 'auto',
                                height: '100%',
                            }}>

                                {/* Basic Information */}
                                {activeTab === 'personal' && (
                                    <>
                                        <Form layout="vertical" form={form}>
                                            <Card
                                                title="Basic Information"
                                                extra={
                                                    modalType === 'edit' ? (
                                                        <span className="d-inline-block data-bs-toggle='tooltip'" title={createEmployeeLoading || updateEmployeeLoading ? 'Saving...' : editingSections.basic ? 'Save' : 'Edit'}>
                                                            <Button
                                                                disabled={createEmployeeLoading || updateEmployeeLoading}
                                                                icon={
                                                                    editingSections.basic ? (
                                                                        createEmployeeLoading || updateEmployeeLoading ? (
                                                                            <span className="spinner-border spinner-border-sm" style={{ color: 'green' }} />
                                                                        ) : (
                                                                            <CheckOutlined style={{ color: 'green', fontSize: 20 }} />
                                                                        )
                                                                    ) : (
                                                                        <EditOutlined />
                                                                    )
                                                                }
                                                                onClick={async (e) => {
                                                                    if (editingSections.basic) {
                                                                        const success = await handleEmployeeSubmit(e, 'full', false, true);
                                                                        if (success) {
                                                                            toggleEdit('basic');
                                                                        }
                                                                    } else {
                                                                        toggleEdit('basic');
                                                                    }
                                                                }}
                                                                style={{
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    gap: 8,
                                                                    fontWeight: 500,
                                                                }}
                                                            />
                                                        </span>
                                                    ) : (
                                                        <span className="d-inline-block" data-bs-toggle="tooltip" title={createEmployeeLoading ? "Saving..." : "Save"}>
                                                            <Button
                                                                disabled={createEmployeeLoading}
                                                                icon={
                                                                    editingSections.basic ? (
                                                                        createEmployeeLoading || updateEmployeeLoading ? (
                                                                            <span className="spinner-border spinner-border-sm" style={{ color: 'green' }} />
                                                                        ) : (
                                                                            <CheckOutlined style={{ color: 'green', fontSize: 20 }} />
                                                                        )
                                                                    ) : (
                                                                        <EditOutlined />
                                                                    )
                                                                }
                                                                onClick={async (e) => {
                                                                    if (!editingSections.basic) return toggleEdit('basic');
                                                                    const success = await handleEmployeeSubmit(e, 'full', false, false, true);
                                                                    if (success) toggleEdit('basic');
                                                                }}
                                                                style={{
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    gap: 8,
                                                                    fontWeight: 500,
                                                                }}
                                                            />
                                                        </span>
                                                    )
                                                }

                                                style={{ marginBottom: 24 }}
                                            >
                                                {/* first name */}
                                                <Row gutter={16} className="mb-2">
                                                    <Col span={12}>
                                                        <label className="form-label">
                                                            First Name <span className="text-danger"> *</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            disabled={!editingSections.basic}
                                                            className="form-control"
                                                            name="firstName"
                                                            value={employeeData.firstName}
                                                            onChange={handleChange}
                                                            placeholder="First Name"
                                                        />
                                                        {employeeErrors.firstName && (
                                                            <span className="text-danger">
                                                                {employeeErrors.firstName}
                                                            </span>
                                                        )}
                                                    </Col>
                                                    {/* last name */}
                                                    <Col span={12}>
                                                        <label className="form-label">
                                                            Last Name <span className="text-danger"> *</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            disabled={!editingSections.basic}
                                                            className="form-control"
                                                            name="lastName"
                                                            value={employeeData.lastName}
                                                            onChange={handleChange}
                                                            placeholder="Last Name"
                                                        />
                                                        {employeeErrors.lastName && (
                                                            <span className="text-danger">
                                                                {employeeErrors.lastName}
                                                            </span>
                                                        )}
                                                    </Col>
                                                </Row>

                                                {/* date of birth */}
                                                <Row gutter={16} className="mb-2">
                                                    <Col span={12}>
                                                        <label className="form-label">
                                                            Date of Birth <span className="text-danger"> *</span>
                                                        </label>
                                                        <div className="input-icon-end position-relative">
                                                            <DatePicker className="form-control datetimepicker" format="DD-MM-YYYY" value={employeeData.dateOfBirth ? dayjs(employeeData.dateOfBirth) : null}
                                                                onChange={(date: any) =>
                                                                    setEmployeeData({
                                                                        ...employeeData,
                                                                        dateOfBirth: date ? date.toDate() : null,
                                                                    })
                                                                }
                                                                disabled={!editingSections.basic}
                                                                placeholder="DD-MM-YYYY"
                                                                defaultPickerValue={dayjs().subtract(18, "year")}
                                                                disabledDate={(current) => {
                                                                    const today = dayjs();
                                                                    const minDOB = today
                                                                        .subtract(18, "year")
                                                                        .endOf("day");
                                                                    return current && current.isAfter(minDOB); // disables future and <18
                                                                }}
                                                            />
                                                            <span className="input-icon-addon">
                                                                <i className="ti ti-calendar text-gray-7" />
                                                            </span>
                                                        </div>
                                                        {employeeErrors.dateOfBirth && (
                                                            <span className="text-danger">
                                                                {employeeErrors.dateOfBirth}
                                                            </span>
                                                        )}
                                                    </Col>

                                                    {/* gender */}
                                                    <Col span={12}>
                                                        <label className="form-label">
                                                            Gender<span className="text-danger"> *</span>
                                                        </label>
                                                        <select
                                                            className="form-control"
                                                            disabled={!editingSections.basic}
                                                            name="gender"
                                                            value={employeeData.gender}
                                                            onChange={handleChange}
                                                        >
                                                            {genderOption.map((option) => (
                                                                <option key={option.value} value={option.value}>
                                                                    {option.label}
                                                                </option>
                                                            ))}
                                                        </select>
                                                        {employeeErrors.gender && (
                                                            <span className="text-danger">
                                                                {employeeErrors.gender}
                                                            </span>
                                                        )}
                                                    </Col>
                                                </Row>

                                                {/* username */}
                                                {planName !== "basic" &&
                                                    <Row gutter={16} className="mb-2">
                                                        <Col span={12} >
                                                            <label className="form-label">
                                                                Username
                                                            </label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                name="username"
                                                                disabled={modalType === "edit" || (modalType === 'create' && !editingSections.basic)}
                                                                value={employeeData.username}
                                                                onChange={handleChange}
                                                            />
                                                            {employeeErrors.username && (
                                                                <span className="text-danger">
                                                                    {employeeErrors.username}
                                                                </span>
                                                            )}
                                                        </Col>
                                                        <Col span={12} >
                                                            <label className="form-label">
                                                                Email <span className="text-danger"> *</span>
                                                            </label>
                                                            <input
                                                                type="email"
                                                                className="form-control"
                                                                name="email"
                                                                disabled={modalType === "edit" || (modalType === 'create' && !editingSections.basic)}
                                                                value={employeeData.email}
                                                                onChange={handleChange}
                                                            />
                                                            {employeeErrors.email && (
                                                                <span className="text-danger">
                                                                    {employeeErrors.email}
                                                                </span>
                                                            )}
                                                        </Col>
                                                    </Row>
                                                }
                                                {/* password */}
                                                <Row gutter={16} className="mb-3">
                                                    {planName !== "basic" &&
                                                        <>
                                                            <Col span={12} >
                                                                <label className="form-label">
                                                                    Password <span className="text-danger"> *</span>
                                                                </label>
                                                                <div className="pass-group">
                                                                    <input
                                                                        type={
                                                                            passwordVisibility.password ? "text" : "password"
                                                                        }
                                                                        className="pass-input form-control"
                                                                        name="password"
                                                                        value={modalType === "edit" ? "**********" : employeeData.password}
                                                                        onChange={handleChange}
                                                                        disabled={modalType === "edit" || (modalType === 'create' && !editingSections.basic)}
                                                                    />
                                                                    <span
                                                                        className={`ti toggle-passwords ${passwordVisibility.password
                                                                            ? "ti-eye"
                                                                            : "ti-eye-off"
                                                                            }`}
                                                                        onClick={() => togglePasswordVisibility("password")}
                                                                    ></span>
                                                                </div>
                                                                {modalType !== "edit" && employeeErrors.password && (
                                                                    <span className="text-danger">{employeeErrors.password}</span>
                                                                )}
                                                            </Col>
                                                            <Col span={12}>
                                                                <label className="form-label">
                                                                    Confirm Password <span className="text-danger"> *</span>
                                                                </label>
                                                                <div className="pass-group">
                                                                    <input
                                                                        type={
                                                                            passwordVisibility.confirmPassword
                                                                                ? "text"
                                                                                : "password"
                                                                        }
                                                                        className="pass-input form-control"
                                                                        name="confirmPassword"
                                                                        value={
                                                                            modalType === "edit" ? "**********" : employeeData.confirmPassword
                                                                        }
                                                                        onChange={handleChange}
                                                                        disabled={modalType === "edit" || (modalType === 'create' && !editingSections.basic)}
                                                                    />
                                                                    <span
                                                                        className={`ti toggle-passwords ${passwordVisibility.confirmPassword
                                                                            ? "ti-eye"
                                                                            : "ti-eye-off"
                                                                            }`}
                                                                        onClick={() =>
                                                                            togglePasswordVisibility("confirmPassword")
                                                                        }
                                                                    ></span>
                                                                </div>
                                                                {modalType !== "edit" && employeeErrors.confirmPassword && (
                                                                    <span className="text-danger">{employeeErrors.confirmPassword}</span>
                                                                )}
                                                            </Col>
                                                        </>
                                                    }
                                                    <Col span={12}>
                                                        <label className="form-label">
                                                            Phone Number <span className="text-danger"> *</span>
                                                        </label>
                                                        <input
                                                            type="tel"
                                                            disabled={!editingSections.basic}
                                                            className="form-control"
                                                            name="phoneNumber"
                                                            value={employeeData.phoneNumber}
                                                            onChange={handleChange}
                                                        />
                                                        {employeeErrors.phoneNumber && (
                                                            <span className="text-danger">
                                                                {employeeErrors.phoneNumber}
                                                            </span>
                                                        )}
                                                    </Col>
                                                    {planName !== "basic" &&
                                                        <Col span={12}>
                                                            <div className="mb-3">
                                                                <label className="form-label">Role</label>{" "}
                                                                <span className="text-danger"> *</span>
                                                                <select
                                                                    className="form-control"
                                                                    name="employeeRole"
                                                                    value={employeeData.employeeRole}
                                                                    onChange={handleChange}
                                                                    disabled={!editingSections.basic}
                                                                >
                                                                    <option value="">Select</option>
                                                                    {rolesData.map((option: any) => (
                                                                        <option key={option.RoleId} value={option.RoleId}>
                                                                            {option.RoleName}
                                                                        </option>
                                                                    ))}
                                                                </select>
                                                                {employeeErrors.employeeRole && (
                                                                    <span className="text-danger">
                                                                        {employeeErrors.employeeRole}
                                                                    </span>
                                                                )}
                                                            </div>
                                                        </Col>
                                                    }
                                                </Row>
                                            </Card>
                                        </Form>

                                        {/* Spouse Details Card */}
                                        <Form layout="vertical">
                                            <Card
                                                title="Spouse Details"
                                                extra={
                                                    modalType === 'edit' ? (
                                                        <span className="'d-inline-block' data-bs-toggle='tooltip'" title={loadingSpouse ? "Saving..." : editingSections.spouse ? "Save" : "Edit"}>
                                                            <Button
                                                                disabled={loadingSpouse}
                                                                icon={
                                                                    loadingSpouse ? (
                                                                        <span className="spinner-border spinner-border-sm" />
                                                                    ) : editingSections.spouse ? (
                                                                        <CheckOutlined style={{ color: 'green', fontSize: 20 }} />
                                                                    ) : (
                                                                        <EditOutlined />
                                                                    )
                                                                }
                                                                onClick={async (e) => {
                                                                    if (editingSections.spouse) {
                                                                        setLoadingSpouse(true);
                                                                        if (await handleSpouseSubmit(e, false, true)) toggleEdit('spouse');
                                                                        setLoadingSpouse(false);
                                                                    } else {
                                                                        toggleEdit('spouse');
                                                                    }
                                                                }}
                                                                style={{
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    gap: 8,
                                                                    fontWeight: 500,
                                                                }}
                                                            /> </span>
                                                    ) : (
                                                        <span className="'d-inline-block' data-bs-toggle='tooltip'" title={loadingSpouse ? "Saving..." : "Save"}>
                                                            <Button
                                                                icon={
                                                                    loadingSpouse ? (
                                                                        <span className="spinner-border spinner-border-sm" />
                                                                    ) : editingSections.spouse ? (
                                                                        <CheckOutlined style={{ color: 'green', fontSize: 20 }} />
                                                                    ) : (
                                                                        <EditOutlined />
                                                                    )
                                                                }
                                                                onClick={async (e) => {
                                                                    if (!createdEmployeeId) {
                                                                        message.warning("Please create employee first before adding spouse details");
                                                                        return;
                                                                    }
                                                                    if (!editingSections.spouse) return toggleEdit('spouse');
                                                                    setLoadingSpouse(true);
                                                                    const success = await handleSpouseSubmit(e, false, true);
                                                                    setLoadingSpouse(false);
                                                                    if (success) toggleEdit('spouse');
                                                                }}
                                                                style={{
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    gap: 8,
                                                                    fontWeight: 500,
                                                                }}
                                                            /></span>
                                                    )
                                                }

                                                style={{ marginBottom: 24 }}
                                            >
                                                <Row gutter={16} className="mb-3">
                                                    <Col span={12}>
                                                        <label className="form-label">
                                                            Spouse Name <span className="text-danger"> *</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            disabled={!editingSections.spouse}
                                                            className="form-control"
                                                            name="spouseName"
                                                            value={spouseData.spouseName}
                                                            onChange={handleSpouseChange}
                                                        />
                                                        {spouseErrors.spouseName && (
                                                            <div className="text-danger">
                                                                {spouseErrors.spouseName}
                                                            </div>
                                                        )}
                                                    </Col>
                                                    <Col span={12}>
                                                        <label className="form-label">
                                                            Date of Birth <span className="text-danger"> *</span>
                                                        </label>

                                                        <div className="input-icon-end position-relative">
                                                            <DatePicker
                                                                type="date"
                                                                className="form-control datetimepicker"
                                                                format="DD-MM-YYYY"
                                                                value={spouseData.spouseDateOfBirth ? dayjs(spouseData.spouseDateOfBirth) : null}
                                                                onChange={(date: any) =>
                                                                    setSpouseData({
                                                                        ...spouseData,
                                                                        spouseDateOfBirth: date ? date.toDate() : null,
                                                                    })
                                                                }
                                                                disabled={!editingSections.spouse}
                                                                placeholder="DD-MM-YYYY"
                                                                defaultPickerValue={dayjs().subtract(18, "year")}
                                                                disabledDate={(current) => {
                                                                    const today = dayjs();
                                                                    const minDOB = today.subtract(18, "year").endOf("day");
                                                                    return current && current.isAfter(minDOB); // disables future dates and under-18
                                                                }}
                                                            />
                                                            <span className="input-icon-addon">
                                                                <i className="ti ti-calendar text-gray-7" />
                                                            </span>
                                                        </div>
                                                        {spouseErrors.spouseDateOfBirth && (
                                                            <div className="text-danger">{spouseErrors.spouseDateOfBirth}</div>
                                                        )}
                                                    </Col>

                                                </Row>

                                                <Row gutter={16} className="mb-3">
                                                    <Col span={12}>
                                                        <label className="form-label">
                                                            Spouse Phone Number{" "}
                                                        </label>
                                                        <input
                                                            type="text"
                                                            disabled={!editingSections.spouse}
                                                            className="form-control"
                                                            name="spousePhone"
                                                            value={spouseData.spousePhone}
                                                            onChange={handleSpouseChange}
                                                        />
                                                        {spouseErrors.spousePhone && (
                                                            <div className="text-danger">
                                                                {spouseErrors.spousePhone}
                                                            </div>
                                                        )}
                                                    </Col>
                                                    <Col span={12}>
                                                        <label className="form-label">
                                                            Spouse Email
                                                        </label>
                                                        <input
                                                            type="email"
                                                            disabled={!editingSections.spouse}
                                                            className="form-control"
                                                            name="spouseEmail"
                                                            value={spouseData.spouseEmail}
                                                            onChange={handleSpouseChange}
                                                        />
                                                        {spouseErrors.spouseEmail && (
                                                            <div className="text-danger">
                                                                {spouseErrors.spouseEmail}
                                                            </div>
                                                        )}
                                                    </Col>
                                                </Row>

                                                <Row gutter={16} className="mb-3">
                                                    <Col span={12}>
                                                        <label className="form-label">Occupation</label>
                                                        <input
                                                            type="text"
                                                            disabled={!editingSections.spouse}
                                                            className="form-control"
                                                            name="spouseProfession"
                                                            value={spouseData.spouseProfession}
                                                            onChange={handleSpouseChange}
                                                        />
                                                    </Col>
                                                    <Col span={12}>
                                                        <label className="form-label">Employer</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            disabled={!editingSections.spouse}
                                                            name="spouseEmployer"
                                                            value={spouseData.spouseEmployer}
                                                            onChange={handleSpouseChange}
                                                        />
                                                    </Col>
                                                </Row>

                                                <Row gutter={16} className="mb-3">
                                                    <Col span={12}>
                                                        <label className="form-label">Spouse Nationality</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            disabled={!editingSections.spouse}
                                                            name="spouseNationality"
                                                            value={spouseData.spouseNationality}
                                                            onChange={handleSpouseChange}
                                                        />
                                                    </Col>
                                                    <Col span={12}>
                                                        <label className="form-label">Anniversary Date</label>
                                                        <div className="input-icon-end position-relative">
                                                            <DatePicker
                                                                className="form-control datetimepicker"
                                                                format="YYYY-MM-DD"
                                                                disabled={!editingSections.spouse}
                                                                value={spouseData.spouseAnniversaryDate ? dayjs(spouseData.spouseAnniversaryDate) : null}
                                                                onChange={(date: any) =>
                                                                    setSpouseData({
                                                                        ...spouseData,
                                                                        spouseAnniversaryDate: date
                                                                            ? date.toDate()
                                                                            : null,
                                                                    })
                                                                }
                                                                placeholder="DD-MM-YYYY"
                                                            />

                                                            <span className="input-icon-addon">
                                                                <i className="ti ti-calendar text-gray-7" />
                                                            </span>
                                                        </div>
                                                    </Col>
                                                </Row>

                                                <Row gutter={16} className="mb-3">
                                                    <Col span={24}>
                                                        <label className="form-label">About Spouse</label>
                                                        <textarea
                                                            className="form-control"
                                                            disabled={!editingSections.spouse}
                                                            rows={2}
                                                            name="spouseDescription"
                                                            value={spouseData.spouseDescription}
                                                            onChange={handleSpouseChange}
                                                        />
                                                    </Col>
                                                </Row>

                                                <Row gutter={16} className="mb-3">
                                                    <Col span={24}>
                                                        <label className="form-label">Address</label>
                                                        <textarea
                                                            disabled={!editingSections.spouse}
                                                            className="form-control"
                                                            rows={2}
                                                            placeholder="Enter Address"
                                                            name="spouseFullAddress"
                                                            value={spouseData.spouseFullAddress}
                                                            onChange={handleSpouseChange}
                                                        />
                                                    </Col>
                                                </Row>
                                            </Card>
                                        </Form>

                                        {/* Children Details Card */}
                                        <Form layout="vertical">
                                            <Card
                                                title="Children Details"
                                                extra={
                                                    <Space>
                                                        <span className="d-inline-block" data-bs-toggle="tooltip" data-bs-placement="top" title={createEmployeeLoading || updateEmployeeLoading ? 'Saving...' : modalType === 'edit' ? editingSections.children ? 'Save' : 'Edit' : 'Save'}>
                                                            <Button
                                                                disabled={createEmployeeLoading || updateEmployeeLoading}
                                                                icon={
                                                                    editingSections.children
                                                                        ? (createEmployeeLoading || updateEmployeeLoading
                                                                            ? <span className="spinner-border spinner-border-sm me-2" />
                                                                            : <CheckOutlined style={{ color: 'green', fontSize: 20 }} />)
                                                                        : <EditOutlined />
                                                                }
                                                                onClick={async () => {
                                                                    if (!createdEmployeeId && modalType !== 'edit') {
                                                                        message.warning("Please create employee first before adding children details");
                                                                        return;
                                                                    }
                                                                    if (!editingSections.children) {
                                                                        toggleEdit('children');
                                                                        return;
                                                                    }
                                                                    const success = await handleAddOrUpdateChild(true);
                                                                    if (success) {
                                                                        toggleEdit('children');
                                                                    }
                                                                }}
                                                            />
                                                        </span>
                                                    </Space>
                                                }

                                                style={{ marginTop: 24, marginBottom: 24 }}
                                            >
                                                {modalType === 'edit' && (
                                                    <div className="mb-4">
                                                        <div
                                                            className="d-flex flex-row"
                                                            style={{
                                                                overflowX: "auto",
                                                                whiteSpace: "nowrap",
                                                                gap: "12px",
                                                                paddingBottom: "8px",
                                                            }}
                                                        >
                                                            {children.map((child, index) => (
                                                                <div
                                                                    key={index}
                                                                    className="card shadow-sm border-2"
                                                                    style={{
                                                                        minWidth: "200px",
                                                                        maxWidth: "200px",
                                                                        flex: "0 0 auto",
                                                                        cursor: "pointer",
                                                                    }}
                                                                    onClick={() => handleEditChild(index)}
                                                                >
                                                                    <div className="card-body d-flex flex-column justify-content-between p-2">
                                                                        <h6 className="card-title mb-1">{child.name || "Unnamed Child"}</h6>
                                                                        <p className="card-text text-muted mb-2">
                                                                            {child.dob ? child.dob.format("DD-MM-YYYY") : "No DOB"}
                                                                        </p>
                                                                        <div className="d-flex justify-content-end">
                                                                            <button
                                                                                type="button"
                                                                                className="btn btn-sm btn-danger"
                                                                                onClick={(e) => {
                                                                                    e.stopPropagation();
                                                                                    handleDeleteChild(index);
                                                                                }}
                                                                            >
                                                                                <i className="bi bi-x-circle" style={{ fontSize: "1.2rem" }}></i>
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>
                                                )}


                                                <div style={{ marginBottom: 16 }}>
                                                    <Row gutter={16}>
                                                        <Col span={12} className="mb-3">
                                                            <label className="form-label">
                                                                Child's Name <span className="text-danger"> *</span>
                                                            </label>
                                                            <input
                                                                type="text"
                                                                disabled={!editingSections.children}
                                                                className="form-control"
                                                                value={childName}
                                                                onChange={(e) => setChildName(e.target.value)}
                                                                placeholder="Enter Child's Name"
                                                            />
                                                        </Col>
                                                        <Col span={12}>
                                                            <label className="form-label">Date of Birth <span className="text-danger"> *</span> </label>
                                                            <div className="input-icon-end position-relative">
                                                                <DatePicker
                                                                    className="form-control datetimepicker"
                                                                    disabled={!editingSections.children}
                                                                    value={childDob}
                                                                    onChange={(date: Dayjs | null) => setChildDob(date)}
                                                                    format="DD-MM-YYYY"
                                                                    placeholder="DD-MM-YYYY"
                                                                />
                                                                <span className="input-icon-addon">
                                                                    <i className="ti ti-calendar text-gray-7" />
                                                                </span>
                                                            </div>
                                                        </Col>
                                                        <Col span={12}>
                                                            <label className="form-label">
                                                                Gender <span className="text-danger"> *</span>
                                                            </label>
                                                            <select
                                                                className="form-control"
                                                                disabled={!editingSections.children}
                                                                value={childGender}
                                                                onChange={(e) => setChildGender(e.target.value)}
                                                            >
                                                                <option value="">Select Gender</option>
                                                                <option value="1">Male</option>
                                                                <option value="2">Female</option>
                                                                <option value="3">Other</option>
                                                            </select>
                                                        </Col>
                                                    </Row>
                                                    <Divider />
                                                </div>
                                            </Card>
                                        </Form>

                                        {/* Parents Details Card */}
                                        <Form layout="vertical">
                                            <Card
                                                title="Parents Details"
                                                extra={
                                                    <Space>
                                                        <span className="d-inline-block 'data-bs-toggle=tooltip'" title={createEmployeeLoading || updateEmployeeLoading ? "Saving..." : modalType === "edit" ? editingSections.parents ? "Save" : "Edit" : "Save"}>
                                                            <Button
                                                                disabled={createEmployeeLoading || updateEmployeeLoading}
                                                                icon={
                                                                    editingSections.parents
                                                                        ? (createEmployeeLoading || updateEmployeeLoading
                                                                            ? <span className="spinner-border spinner-border-sm me-2" />
                                                                            : <CheckOutlined style={{ color: 'green', fontSize: 20 }} />)
                                                                        : <EditOutlined />
                                                                }
                                                                onClick={async (e) => {
                                                                    if (!createdEmployeeId && modalType !== 'edit') {
                                                                        message.warning("Please create employee first before adding parents details");
                                                                        return
                                                                    }
                                                                    if (!editingSections.parents) {
                                                                        toggleEdit('parents');
                                                                        return;
                                                                    }
                                                                    const success = await handleParentSubmit(e, false, true);
                                                                    if (success) {
                                                                        toggleEdit('parents');
                                                                    }
                                                                }}
                                                            />
                                                        </span>
                                                    </Space>
                                                }
                                                style={{ marginTop: 24, marginBottom: 24 }}
                                            >
                                                <div style={{ marginBottom: 16 }}>
                                                    <Row gutter={16}>
                                                        {/* Father's Name */}
                                                        <Col span={12} className="mb-3">
                                                            <label className="form-label">
                                                                Father's Name <span className="text-danger"> *</span>
                                                            </label>
                                                            <input
                                                                type="text"
                                                                disabled={!editingSections.parents}
                                                                className="form-control"
                                                                name="fatherName"
                                                                value={parentData.fatherName}
                                                                onChange={handleParentChange}
                                                            />
                                                            {parentErrors.fatherName && (
                                                                <div className="text-danger">
                                                                    {parentErrors.fatherName}
                                                                </div>
                                                            )}
                                                        </Col>

                                                        {/* Mother's Name */}
                                                        <Col span={12} className="mb-3">
                                                            <label className="form-label">
                                                                Mother's Name <span className="text-danger"> *</span>
                                                            </label>
                                                            <input
                                                                type="text"
                                                                disabled={!editingSections.parents}
                                                                className="form-control"
                                                                name="motherName"
                                                                value={parentData.motherName}
                                                                onChange={handleParentChange}
                                                            />
                                                            {parentErrors.motherName && (
                                                                <div className="text-danger">
                                                                    {parentErrors.motherName}
                                                                </div>
                                                            )}
                                                        </Col>

                                                        {/* Father's Phone */}
                                                        <Col span={12} className="mb-3">
                                                            <label className="form-label">
                                                                Father's Phone Number{" "}
                                                            </label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                disabled={!editingSections.parents}
                                                                name="fatherPhone"
                                                                value={parentData.fatherPhone}
                                                                onChange={handleParentChange}
                                                            />
                                                            {parentErrors.fatherPhone && (
                                                                <div className="text-danger">
                                                                    {parentErrors.fatherPhone}
                                                                </div>
                                                            )}
                                                        </Col>

                                                        {/* Mother's Phone */}
                                                        <Col span={12} className="mb-3">
                                                            <label className="form-label">
                                                                Mother's Phone Number{" "}
                                                            </label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                disabled={!editingSections.parents}
                                                                name="motherPhone"
                                                                value={parentData.motherPhone}
                                                                onChange={handleParentChange}
                                                            />
                                                            {parentErrors.motherPhone && (
                                                                <div className="text-danger">
                                                                    {parentErrors.motherPhone}
                                                                </div>
                                                            )}
                                                        </Col>

                                                        {/* Father's Email */}
                                                        <Col span={12} className="mb-3">
                                                            <label className="form-label">
                                                                Father's Email
                                                            </label>
                                                            <input
                                                                type="email"
                                                                className="form-control"
                                                                disabled={!editingSections.parents}
                                                                name="fatherEmail"
                                                                value={parentData.fatherEmail}
                                                                onChange={handleParentChange}
                                                            />
                                                            {parentErrors.fatherEmail && (
                                                                <div className="text-danger">
                                                                    {parentErrors.fatherEmail}
                                                                </div>
                                                            )}
                                                        </Col>

                                                        {/* Mother's Email */}
                                                        <Col span={12} className="mb-3">
                                                            <label className="form-label">
                                                                Mother's Email
                                                            </label>
                                                            <input
                                                                type="email"
                                                                className="form-control"
                                                                disabled={!editingSections.parents}
                                                                name="motherEmail"
                                                                value={parentData.motherEmail}
                                                                onChange={handleParentChange}
                                                            />
                                                            {parentErrors.motherEmail && (
                                                                <div className="text-danger">
                                                                    {parentErrors.motherEmail}
                                                                </div>
                                                            )}
                                                        </Col>

                                                        {/* Father's DOB */}
                                                        <Col span={12} className="mb-3">
                                                            <label className="form-label">
                                                                Father's Date of Birth
                                                            </label>
                                                            <div className="input-icon-end position-relative">
                                                                <DatePicker
                                                                    className="form-control datetimepicker"
                                                                    format="DD-MM-YYYY"
                                                                    value={
                                                                        parentData.fatherDateOfBirth
                                                                            ? dayjs(parentData.fatherDateOfBirth)
                                                                            : null
                                                                    }
                                                                    onChange={(date: any) =>
                                                                        setParentData({
                                                                            ...parentData,
                                                                            fatherDateOfBirth: date
                                                                                ? date.toDate()
                                                                                : null,
                                                                        })
                                                                    }
                                                                    placeholder="DD-MM-YYYY"
                                                                    disabled={!editingSections.parents}
                                                                    defaultPickerValue={dayjs().subtract(18, "year")}
                                                                    disabledDate={(current) => {
                                                                        const today = dayjs();
                                                                        const minDOB = today.subtract(18, "year").endOf("day");
                                                                        return current && current.isAfter(minDOB); // disables future dates & under-18
                                                                    }}
                                                                />
                                                                <span className="input-icon-addon">
                                                                    <i className="ti ti-calendar text-gray-7" />
                                                                </span>
                                                            </div>
                                                        </Col>

                                                        {/* Mother's DOB */}
                                                        <Col span={12} className="mb-3">
                                                            <label className="form-label">
                                                                Mother's Date of Birth
                                                            </label>
                                                            <div className="input-icon-end position-relative">
                                                                <DatePicker
                                                                    className="form-control datetimepicker"
                                                                    format="DD-MM-YYYY"
                                                                    value={
                                                                        parentData.motherDateOfBirth
                                                                            ? dayjs(parentData.motherDateOfBirth)
                                                                            : null
                                                                    }
                                                                    onChange={(date: any) =>
                                                                        setParentData({
                                                                            ...parentData,
                                                                            motherDateOfBirth: date
                                                                                ? date.toDate()
                                                                                : null,
                                                                        })
                                                                    }
                                                                    placeholder="DD-MM-YYYY"
                                                                    disabled={!editingSections.parents}
                                                                    defaultPickerValue={dayjs().subtract(18, "year")}
                                                                    disabledDate={(current) => {
                                                                        const today = dayjs();
                                                                        const minDOB = today.subtract(18, "year").endOf("day");
                                                                        return current && current.isAfter(minDOB); // Disable future & under-18
                                                                    }}
                                                                />
                                                                <span className="input-icon-addon">
                                                                    <i className="ti ti-calendar text-gray-7" />
                                                                </span>
                                                            </div>
                                                        </Col>

                                                        {/* Father's Occupation */}
                                                        <Col span={12} className="mb-3">
                                                            <label className="form-label">Father's Occupation</label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                disabled={!editingSections.parents}
                                                                name="fatherOccupation"
                                                                value={parentData.fatherOccupation}
                                                                onChange={handleParentChange}
                                                            />
                                                        </Col>

                                                        {/* Mother's Occupation */}
                                                        <Col span={12} className="mb-3">
                                                            <label className="form-label">Mother's Occupation</label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                name="motherOccupation"
                                                                disabled={!editingSections.parents}
                                                                value={parentData.motherOccupation}
                                                                onChange={handleParentChange}
                                                            />
                                                        </Col>

                                                        {/* Address */}
                                                        <Col span={24} className="mb-3">
                                                            <label className="form-label">
                                                                Address
                                                            </label>
                                                            <textarea
                                                                className="form-control"
                                                                rows={2}
                                                                name="address"
                                                                disabled={!editingSections.parents}
                                                                value={parentData.address}
                                                                onChange={handleParentChange}
                                                            />
                                                            {parentErrors.address && <span className="text-danger">{parentErrors.address}</span>}
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </Card>
                                        </Form>

                                        {/* Additional Information Card */}
                                        <Form layout="vertical">
                                            <Card
                                                title="Additional Information"
                                                extra={
                                                    <span className="d-inline-block data-bs-toggle='tooltip'" title={createEmployeeLoading || updateEmployeeLoading ? "Saving..." : modalType === "edit" ? editingSections.additional ? "Save" : "Edit" : "Save"}>
                                                        <Button
                                                            disabled={createEmployeeLoading || updateEmployeeLoading}
                                                            icon={
                                                                editingSections.additional
                                                                    ? (createEmployeeLoading || updateEmployeeLoading
                                                                        ? <span className="spinner-border spinner-border-sm me-2" />
                                                                        : <CheckOutlined style={{ color: 'green', fontSize: 20 }} />)
                                                                    : <EditOutlined />
                                                            }
                                                            onClick={async (e) => {
                                                                if (!createdEmployeeId && modalType !== "edit") {
                                                                    message.warning("Please create employee first before adding additional information")
                                                                    return
                                                                }
                                                                if (!editingSections.additional) {
                                                                    toggleEdit('additional');
                                                                    return;
                                                                }
                                                                const success = await handleEmployeeSubmit(e, 'additional', false, true);
                                                                if (success) {
                                                                    toggleEdit('additional');
                                                                }
                                                            }}
                                                        />
                                                    </span>
                                                }

                                                style={{ marginBottom: 24 }}
                                            >
                                                <label className="form-label">
                                                    About
                                                </label>
                                                <textarea
                                                    className="form-control"
                                                    disabled={!editingSections.additional}
                                                    rows={3}
                                                    value={employeeData.about}
                                                    onChange={handleChange}
                                                    name="about"
                                                />
                                                {employeeErrors.about && <span className="text-danger">{employeeErrors.about}</span>}
                                            </Card>
                                        </Form>
                                    </>
                                )}
                                {/* Combined Employment Tab */}
                                {activeTab === 'employment' && (
                                    <>
                                        {/* Employment Details Card */}
                                        <Form layout="vertical">
                                            <Card
                                                title="Employment Details"
                                                extra={
                                                    <span
                                                        className="d-inline-block"
                                                        data-bs-toggle="tooltip"
                                                        title={
                                                            loadingEmployement
                                                                ? "Saving..."
                                                                : modalType === "edit"
                                                                    ? editingSections.employment
                                                                        ? "Save"
                                                                        : "Edit"
                                                                    : "Save"
                                                        }
                                                    >
                                                        {modalType === 'edit' ? (
                                                            <Button
                                                                disabled={loadingEmployement}
                                                                icon={
                                                                    loadingEmployement ? (
                                                                        <span className="spinner-border spinner-border-sm" />
                                                                    ) : editingSections.employment ? (
                                                                        <CheckOutlined style={{ color: 'green', fontSize: 20 }} />
                                                                    ) : (
                                                                        <EditOutlined />
                                                                    )
                                                                }
                                                                onClick={async (e) => {
                                                                    if (editingSections.employment) {
                                                                        setLoadingEmployement(true);
                                                                        const success = await handleEmployeeSubmit(e, 'employement', false, true);
                                                                        setLoadingEmployement(false);
                                                                        if (success) toggleEdit('employment');
                                                                    } else {
                                                                        toggleEdit('employment');
                                                                    }
                                                                }}
                                                                style={{
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    gap: 8
                                                                }}
                                                            />
                                                        ) : (
                                                            <Button
                                                                icon={
                                                                    loadingEmployement ? (
                                                                        <span className="spinner-border spinner-border-sm" />
                                                                    ) : editingSections.employment ? (
                                                                        <CheckOutlined style={{ color: 'green', fontSize: 20 }} />
                                                                    ) : (
                                                                        <EditOutlined />
                                                                    )
                                                                }
                                                                onClick={async (e) => {
                                                                    if (!editingSections.employment) return toggleEdit('employment');
                                                                    setLoadingEmployement(true);
                                                                    const success = await handleEmployeeSubmit(e, 'employement', false, true);
                                                                    setLoadingEmployement(false);
                                                                    if (success) toggleEdit('employment');
                                                                }}
                                                                style={{
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    gap: 8
                                                                }}
                                                            />
                                                        )}</span>
                                                }

                                                style={{ marginBottom: 24 }}
                                            >
                                                <Row gutter={16} className="mb-4">
                                                    <Col span={12}>
                                                        <label className="form-label">
                                                            Employment Type<span className="text-danger"> *</span>
                                                        </label>
                                                        <select
                                                            className="form-control"
                                                            name="employmentType"
                                                            value={employeeData.employmentType}
                                                            onChange={handleChange}
                                                            disabled={!editingSections.employment}
                                                        >
                                                            <option value="">Select</option>
                                                            {Object.values(EmploymentType).map((option) => (
                                                                <option key={option} value={option}>
                                                                    {option}
                                                                </option>
                                                            ))}
                                                        </select>
                                                        {employeeErrors.employmentType && (
                                                            <span className="text-danger">
                                                                {employeeErrors.employmentType}
                                                            </span>
                                                        )}
                                                    </Col>
                                                    <Col span={12}>
                                                        <label className="form-label">
                                                            Work Preference<span className="text-danger"> *</span>
                                                        </label>
                                                        <select
                                                            className="form-control"
                                                            name="workPreference"
                                                            value={employeeData.workPreference}
                                                            disabled={!editingSections.employment}
                                                            onChange={handleChange}
                                                        >
                                                            <option value="">Select</option>
                                                            {Object.values(WorkPreference).map((option) => (
                                                                <option key={option} value={option}>
                                                                    {option}
                                                                </option>
                                                            ))}
                                                        </select>
                                                        {employeeErrors.workPreference && (
                                                            <span className="text-danger">
                                                                {employeeErrors.workPreference}
                                                            </span>
                                                        )}
                                                    </Col>
                                                </Row>

                                                <Row gutter={16} className="mb-3">
                                                    <Col span={12}>
                                                        <label className="form-label">
                                                            Joining Date <span className="text-danger"> *</span>
                                                        </label>
                                                        <div className="input-icon-end position-relative">
                                                            <DatePicker
                                                                className="form-control datetimepicker"
                                                                format="DD-MM-YYYY"
                                                                disabled={!editingSections.employment}
                                                                value={
                                                                    employeeData.joiningDate
                                                                        ? dayjs(employeeData.joiningDate)
                                                                        : dayjs()
                                                                }
                                                                onChange={(date: any) =>
                                                                    setEmployeeData({
                                                                        ...employeeData,
                                                                        joiningDate: date ? date.toDate() : dayjs().toDate(),
                                                                    })
                                                                }
                                                                placeholder="DD-MM-YYYY"
                                                            />
                                                            <span className="input-icon-addon">
                                                                <i className="ti ti-calendar text-gray-7" />
                                                            </span>
                                                        </div>
                                                        {employeeErrors.joiningDate && (
                                                            <span className="text-danger">
                                                                {employeeErrors.joiningDate}
                                                            </span>
                                                        )}
                                                    </Col>
                                                    <Col span={12}>
                                                        <label className="form-label">Experience Level</label>
                                                        <span className="text-danger"> *</span>
                                                        <select
                                                            className="form-control"
                                                            name="experiencelabel"
                                                            value={employeeData.experiencelabel}
                                                            disabled={!editingSections.employment}
                                                            onChange={handleChange}
                                                        >
                                                            <option value="">Select</option>
                                                            {activeExperience?.map((option: any) => (
                                                                <option key={option.Id} value={option.Id.toString()}>
                                                                    {option.Label}
                                                                </option>
                                                            ))}
                                                        </select>
                                                        {employeeErrors.experiencelabel && (
                                                            <span className="text-danger">
                                                                {employeeErrors.experiencelabel}
                                                            </span>
                                                        )}
                                                    </Col>
                                                    <Col span={12} className="mt-3">
                                                        <label className="form-label">Reporting Manager</label>
                                                        <select
                                                            className="form-control"
                                                            name="reportingManager"
                                                            disabled={!editingSections.employment}
                                                            value={employeeData.reportingManager}
                                                            onChange={handleChange}
                                                        >
                                                            <option value="">Select</option>
                                                            {(activeReportingManager)
                                                                ?.slice()
                                                                ?.sort((a: any, b: any) => a.Name.localeCompare(b.Name))
                                                                ?.map((option: any) => (
                                                                    <option key={option.EmployeeID} value={option.EmployeeID}>
                                                                        {option.Name}
                                                                    </option>
                                                                ))}
                                                        </select>
                                                    </Col>
                                                    {/* HR */}
                                                    <Col span={12} className="mt-3">
                                                        <label className="form-label">HR</label>
                                                        <select
                                                            className="form-control"
                                                            name="hr"
                                                            disabled={!editingSections.employment}
                                                            value={String(employeeData.hr || '')}
                                                            onChange={handleChange}
                                                        >
                                                            <option value="">Select HR</option>
                                                            {filteredHR
                                                                ?.slice()
                                                                .sort((a: any, b: any) => a.Name.localeCompare(b.Name, undefined, { sensitivity: 'base' }))
                                                                .map((option: any) => (
                                                                    <option key={option.EmployeeID} value={option.EmployeeID}>
                                                                        {option.Name}
                                                                    </option>
                                                                ))}
                                                        </select>
                                                    </Col>
                                                    <Col span={12} className="mt-3">
                                                        <label className="form-label">HOD</label>
                                                        <select
                                                            className="form-control"
                                                            name="hod"
                                                            disabled={!editingSections.employment}
                                                            value={String(employeeData.hod || '')}
                                                            onChange={handleChange}
                                                        >
                                                            <option value="">Select HOD</option>
                                                            {activeHOD
                                                                ?.slice()
                                                                .sort((a: any, b: any) => a.Name.localeCompare(b.Name, undefined, { sensitivity: 'base' }))
                                                                .map((option: any) => (
                                                                    <option key={option.EmployeeID} value={option.EmployeeID}>
                                                                        {option.Name}
                                                                    </option>
                                                                ))}
                                                        </select>
                                                    </Col>
                                                </Row>
                                                {/* pf and track location checkbox */}
                                                <Row gutter={16}>
                                                    <Col span={12}>
                                                        <label className="d-inline-flex align-items-center">
                                                            <input
                                                                type="checkbox"
                                                                name="pfEnable"
                                                                disabled={!editingSections.employment}
                                                                checked={employeeData.pfEnable}
                                                                onChange={handleChange}
                                                                className="me-2"
                                                            />
                                                            {config?.pf_reporting_enabled ? "Enable EPF" : "Enable GPF"}
                                                        </label>
                                                        {employeeErrors.pfEnable && (
                                                            <span className="text-danger">
                                                                {employeeErrors.pfEnable}
                                                            </span>
                                                        )}
                                                    </Col>
                                                    <Col span={12}>
                                                        <label className="d-inline-flex align-items-center">
                                                            <input
                                                                type="checkbox"
                                                                name="locationTracking"
                                                                disabled={!editingSections.employment}
                                                                checked={employeeData.locationTracking}
                                                                onChange={handleChange}
                                                                className="me-2"
                                                            />
                                                            Track Location
                                                        </label>
                                                    </Col>
                                                </Row>
                                            </Card>
                                        </Form>
                                        {/* Job Information Card */}
                                        <Form layout="vertical">
                                            <Card
                                                title="Job Information"
                                                extra={
                                                    <span
                                                        className="d-inline-block"
                                                        data-bs-toggle="tooltip"
                                                        title={
                                                            loadingJobInfo
                                                                ? "Saving..."
                                                                : modalType === "edit"
                                                                    ? editingSections.job
                                                                        ? "Save"
                                                                        : "Edit"
                                                                    : "Save"
                                                        }
                                                    >
                                                        {modalType === 'edit' ? (
                                                            <Button
                                                                disabled={loadingJobInfo}
                                                                icon={
                                                                    loadingJobInfo ? (
                                                                        <span className="spinner-border spinner-border-sm" />
                                                                    ) : editingSections.job ? (
                                                                        <CheckOutlined style={{ color: 'green', fontSize: 20 }} />
                                                                    ) : (
                                                                        <EditOutlined />
                                                                    )
                                                                }
                                                                onClick={async (e) => {
                                                                    if (editingSections.job) {
                                                                        setLoadingJobInfo(true);
                                                                        (await handleEmployeeSubmit(e, 'jobInfo', false, true)) && toggleEdit('job');
                                                                        setLoadingJobInfo(false);
                                                                    } else toggleEdit('job');
                                                                }}
                                                                style={{
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    gap: 8
                                                                }}
                                                            />
                                                        ) : (
                                                            <Button
                                                                icon={
                                                                    loadingJobInfo ? (
                                                                        <span className="spinner-border spinner-border-sm" />
                                                                    ) : editingSections.job ? (
                                                                        <CheckOutlined style={{ color: 'green', fontSize: 20 }} />
                                                                    ) : (
                                                                        <EditOutlined />
                                                                    )
                                                                }
                                                                onClick={async (e) => {
                                                                    if (!editingSections.job) return toggleEdit('job');
                                                                    setLoadingJobInfo(true);
                                                                    (await handleEmployeeSubmit(e, 'jobInfo', false, true)) && toggleEdit('job');
                                                                    setLoadingJobInfo(false);
                                                                }}
                                                                style={{
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    gap: 8
                                                                }}
                                                            />
                                                        )}</span>
                                                }

                                                style={{ marginBottom: 24 }}
                                            >
                                                <Row gutter={16} className="mb-4">
                                                    <Col span={12}>
                                                        <label className="form-label">Department</label> <span className="text-danger"> *</span>
                                                        <select
                                                            className="form-control"
                                                            disabled={!editingSections.job}
                                                            name="department"
                                                            value={employeeData.department}
                                                            onChange={handleChangeWrapped}  // <-- use the wrapper to auto-clear HR if needed
                                                        >
                                                            <option value="">Select</option>
                                                            {activeDepartment
                                                                ?.slice()
                                                                .sort((a: any, b: any) => a.Name.localeCompare(b.Name, undefined, { sensitivity: 'base' }))
                                                                .map((option: any) => (
                                                                    <option key={option.Id} value={option.Id}>
                                                                        {option.Name}
                                                                    </option>
                                                                ))}
                                                        </select>

                                                        {employeeErrors.department && (
                                                            <span className="text-danger">{employeeErrors.department}</span>
                                                        )}
                                                    </Col>
                                                    <Col span={12}>
                                                        <label className="form-label">Designation</label>{" "}
                                                        <span className="text-danger"> *</span>
                                                        <select
                                                            className="form-control"
                                                            disabled={!editingSections.job}
                                                            name="designation"
                                                            value={employeeData.designation}
                                                            onChange={handleChange}
                                                        >
                                                            <option value="">Select</option>
                                                            {activeEmployeeDesignation
                                                                ?.slice()
                                                                .sort((a: any, b: any) => a.DesignationName.localeCompare(b.DesignationName))
                                                                .map((option: any) => (
                                                                    <option key={option.DesignationId} value={option.DesignationId}>
                                                                        {option.DesignationName}
                                                                    </option>
                                                                ))}
                                                        </select>
                                                        {employeeErrors.designation && (
                                                            <span className="text-danger">{employeeErrors.designation}</span>
                                                        )}
                                                    </Col>

                                                </Row>

                                                <Row gutter={16}>
                                                    <Col span={12}>
                                                        <label className="form-label">
                                                            Company<span className="text-danger"> *</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            name="company"
                                                            value={employeeData.company}
                                                            onChange={handleChange}
                                                            disabled
                                                        />
                                                        {employeeErrors.company && (
                                                            <span className="text-danger">
                                                                {employeeErrors.company}
                                                            </span>
                                                        )}
                                                    </Col>
                                                    <Col span={12}>
                                                        <label className="form-label">Status</label>{" "}
                                                        <span className="text-danger ms-2">*</span>
                                                        <select
                                                            className="form-control"
                                                            disabled={!editingSections.job}
                                                            name="employee_status"
                                                            value={employeeData.employee_status}
                                                            onChange={handleChange}
                                                        >
                                                            {status.map((status: any) => (
                                                                <option key={status.value} value={status.value}>
                                                                    {status.label}
                                                                </option>
                                                            ))}
                                                        </select>
                                                        {employeeErrors.employee_status && (
                                                            <small className="text-danger">
                                                                {employeeErrors.employee_status}
                                                            </small>
                                                        )}
                                                    </Col>
                                                </Row>
                                            </Card>
                                        </Form>

                                        {/* Location Information Card */}
                                        <Form layout="vertical">
                                            <Card
                                                title="Location Information"
                                                extra={
                                                    <span className="d-link-block data-bs-toggle='tooltip'" title={locationInfoLoading ? 'Saving...' : modalType === 'edit' ? editingSections.location ? 'Save' : 'Edit' : 'Save'}>
                                                        {modalType === 'edit' ? (
                                                            <Button
                                                                disabled={locationInfoLoading}
                                                                icon={
                                                                    locationInfoLoading ? (
                                                                        <span className="spinner-border spinner-border-sm" />
                                                                    ) : editingSections.location ? (
                                                                        <CheckOutlined style={{ color: 'green', fontSize: 20 }} />
                                                                    ) : (
                                                                        <EditOutlined />
                                                                    )
                                                                }
                                                                onClick={async (e) => {
                                                                    if (editingSections.location) {
                                                                        setLocationInfoLoading(true);
                                                                        (await handleEmployeeSubmit(e, 'location_info', false, true)) && toggleEdit('location');
                                                                        setLocationInfoLoading(false);
                                                                    } else toggleEdit('location');
                                                                }}
                                                            />
                                                        ) : (
                                                            <Button
                                                                icon={
                                                                    locationInfoLoading ? (
                                                                        <span className="spinner-border spinner-border-sm" />
                                                                    ) : editingSections.location ? (
                                                                        <CheckOutlined style={{ color: 'green', fontSize: 20 }} />
                                                                    ) : (
                                                                        <EditOutlined />
                                                                    )
                                                                }
                                                                onClick={async (e) => {
                                                                    if (!editingSections.location) return toggleEdit('location');
                                                                    setLocationInfoLoading(true);
                                                                    const success = await handleEmployeeSubmit(e, 'location_info', false, true);
                                                                    setLocationInfoLoading(false);
                                                                    if (success) toggleEdit('location');
                                                                }}
                                                            />
                                                        )}</span>
                                                }
                                                style={{ marginBottom: 24 }}
                                            >
                                                <Row gutter={16}>
                                                    <Col span={12}>
                                                        <label className="form-label">Branch</label>{" "}
                                                        <span className="text-danger ms-2">*</span>
                                                        <select
                                                            className="form-control"
                                                            disabled={!editingSections.location}
                                                            name="branch"
                                                            value={employeeData.branch}
                                                            onChange={handleChange}
                                                        >
                                                            <option value="">Select</option>
                                                            {ActiveBranch
                                                                ?.slice()
                                                                .sort((a: any, b: any) => a.Branch_Name.localeCompare(b.Branch_Name, undefined, { sensitivity: 'base' }))
                                                                .map((status: any) => (
                                                                    <option key={status.Id} value={status.Id}>
                                                                        {status.Branch_Name}
                                                                    </option>
                                                                ))}
                                                        </select>

                                                        {employeeErrors.branch && (
                                                            <small className="text-danger">
                                                                {employeeErrors.branch}
                                                            </small>
                                                        )}
                                                    </Col>
                                                    <Col span={12} className="mb-3">
                                                        <label className="form-label">Job location</label>
                                                        <span className="text-danger ms-2">*</span>
                                                        <input
                                                            type="text"
                                                            list="jobLocationList"
                                                            className="form-control"
                                                            name="job_location"
                                                            value={employeeData.job_location}
                                                            onChange={handleChange}
                                                            disabled={employeeData.checked}
                                                        />

                                                        <datalist id="jobLocationList">
                                                            {joblocation?.map((status: any) => (
                                                                <option
                                                                    key={status.Id}
                                                                    value={status.job_location}
                                                                />
                                                            ))}
                                                        </datalist>

                                                        <datalist id="jobLocationList">
                                                            {branch?.map((status: any) => (
                                                                <option
                                                                    key={status.Id}
                                                                    value={status.Branch_Name}
                                                                />
                                                            ))}
                                                        </datalist>
                                                        {employeeErrors.job_location && (
                                                            <small className="text-danger">
                                                                {employeeErrors.job_location}
                                                            </small>
                                                        )}
                                                    </Col>
                                                    <div className="col-md-12 d-flex align-items-center mb-3 mx-2">
                                                        <input
                                                            type="checkbox"
                                                            className="form-check-input me-2"
                                                            checked={employeeData.checked ?? false}
                                                            disabled={!editingSections.location}
                                                            onChange={(e) => {
                                                                const isChecked = e.target.checked;

                                                                setEmployeeData((prev: any) => ({
                                                                    ...prev,
                                                                    checked: isChecked,
                                                                    job_location: isChecked
                                                                        ? branch.find(
                                                                            (b: any) => b.Id === parseInt(prev.branch)
                                                                        )?.Branch_Name || ""
                                                                        : prev.job_location,
                                                                }));
                                                            }}
                                                        />
                                                        <label className="form-check-label">Same as Branch</label>
                                                    </div>
                                                </Row>
                                            </Card>
                                        </Form>

                                        {/* Work Experience Card */}
                                        <Form layout="vertical">
                                            <Card
                                                title="Work Experience"
                                                extra={
                                                    <Space>
                                                        <span className="d-inline-block" data-bs-toggle="tooltip" title={modalType === "edit" ? editingSections.experience ? "Save" : "Edit" : "Save"}>
                                                            {modalType === 'edit' ? (
                                                                <Button
                                                                    icon={editingSections.experience ? (
                                                                        <CheckOutlined style={{ color: 'green', fontSize: 20 }} />
                                                                    ) : (
                                                                        <EditOutlined />
                                                                    )}
                                                                    onClick={async () => {
                                                                        if (editingSections.experience) {
                                                                            const success = await handleAddOrUpdateAndSaveExperience(true);
                                                                            if (success) {
                                                                                toggleEdit('experience');
                                                                            }
                                                                        } else {
                                                                            toggleEdit('experience');
                                                                        }
                                                                    }}
                                                                />
                                                            ) : (
                                                                <Button
                                                                    icon={editingSections.experience ? (
                                                                        <CheckOutlined style={{ color: 'green', fontSize: 20 }} />
                                                                    ) : (
                                                                        <EditOutlined />
                                                                    )}
                                                                    onClick={async () => {
                                                                        if (!editingSections.experience) return toggleEdit('experience')
                                                                        const success = await handleAddOrUpdateAndSaveExperience(true);
                                                                        if (success) toggleEdit('experience');
                                                                    }}
                                                                >
                                                                </Button>
                                                            )}</span>
                                                    </Space>
                                                }
                                            >
                                                <div className="modal-body pb-0">

                                                    {modalType === "edit" && (
                                                        <div
                                                            className="d-flex overflow-auto pb-3"
                                                            style={{
                                                                gap: "1rem",
                                                                padding: "1%",
                                                                paddingBottom: "1rem",
                                                                whiteSpace: "nowrap",
                                                            }}
                                                        >
                                                            {experiences.map((experience, index) => (
                                                                <div
                                                                    key={index}
                                                                    onClick={() => handleEditExperience(index)}
                                                                    className={`card p-3 shadow-sm ${index === selectedExperienceIndex ? "border-primary" : ""}`}
                                                                    style={{
                                                                        minWidth: "200px",
                                                                        maxWidth: "200px",
                                                                        borderRadius: "10px",
                                                                        cursor: "pointer",
                                                                        display: "inline-block",
                                                                        transition: "transform 0.2s ease",
                                                                    }}
                                                                    onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.03)")}
                                                                    onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
                                                                >
                                                                    <div className="d-flex justify-content-between align-items-start">
                                                                        <div>
                                                                            <h6 className="mb-1">{experience.companyName}</h6>
                                                                            <p className="mb-0 text-muted" style={{ fontSize: "0.85rem" }}>
                                                                                {experience.jobTitle}
                                                                            </p>
                                                                            <p className="mb-0 text-muted" style={{ fontSize: "0.75rem" }}>
                                                                                {experience.startDate
                                                                                    ? dayjs(experience.startDate).format("DD-MM-YYYY")
                                                                                    : ""}
                                                                                {" - "}
                                                                                {experience.endDate
                                                                                    ? dayjs(experience.endDate).format("DD-MM-YYYY")
                                                                                    : "Present"}
                                                                            </p>
                                                                        </div>

                                                                        {/* Delete Icon */}
                                                                        <i
                                                                            onClick={(e) => {
                                                                                if (modalType === 'edit' && !editingSections.experience) return; // Prevent action if disabled
                                                                                e.stopPropagation();
                                                                                handleDeleteExperience(index);
                                                                            }}
                                                                            className="bi bi-trash"
                                                                            style={{
                                                                                fontSize: "1.2rem",
                                                                                color: modalType === 'edit' && !editingSections.experience ? "#ccc" : "red",
                                                                                cursor: modalType === 'edit' && !editingSections.experience ? "not-allowed" : "pointer",
                                                                                pointerEvents: modalType === 'edit' && !editingSections.experience ? "none" : "auto"
                                                                            }}
                                                                        ></i>

                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    )}

                                                    <Row gutter={16} className="mb-4">
                                                        <Col span={12}>
                                                            <label className="form-label">
                                                                Company Name <span className="text-danger"> *</span>
                                                            </label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                disabled={!editingSections.experience}
                                                                placeholder="Enter Company Name"
                                                                value={newExperience.companyName}
                                                                onChange={(e) =>
                                                                    setNewExperience({
                                                                        ...newExperience,
                                                                        companyName: e.target.value,
                                                                    })
                                                                }
                                                            />
                                                        </Col>
                                                        <Col span={12}>
                                                            <label className="form-label">
                                                                Job Title <span className="text-danger"> *</span>
                                                            </label>
                                                            <input
                                                                type="text"
                                                                disabled={!editingSections.experience}
                                                                className="form-control"
                                                                placeholder="Enter Job Title"
                                                                value={newExperience.jobTitle}
                                                                onChange={(e) =>
                                                                    setNewExperience({
                                                                        ...newExperience,
                                                                        jobTitle: e.target.value,
                                                                    })
                                                                }
                                                            />
                                                        </Col>
                                                    </Row>

                                                    <Row gutter={16} className="mb-4">
                                                        <Col span={12}>
                                                            <label className="form-label">
                                                                Start Date <span className="text-danger"> *</span>
                                                            </label>
                                                            <input
                                                                type="date"
                                                                disabled={!editingSections.experience}
                                                                className="form-control"
                                                                value={
                                                                    newExperience.startDate
                                                                        ? newExperience.startDate.toString().split("T")[0]
                                                                        : ""
                                                                }
                                                                onChange={(e) =>
                                                                    setNewExperience({
                                                                        ...newExperience,
                                                                        startDate: e.target.value,
                                                                    })
                                                                }
                                                            />
                                                        </Col>
                                                        <Col span={12}>
                                                            <label className="form-label">
                                                                End Date <span className="text-danger"> *</span>
                                                            </label>
                                                            <input
                                                                type="date"
                                                                disabled={!editingSections.experience}
                                                                className="form-control"
                                                                value={
                                                                    newExperience.endDate
                                                                        ? newExperience.endDate.toString().split("T")[0]
                                                                        : ""
                                                                }
                                                                onChange={(e) =>
                                                                    setNewExperience({
                                                                        ...newExperience,
                                                                        endDate: e.target.value,
                                                                    })
                                                                }
                                                            />
                                                        </Col>
                                                    </Row>

                                                    <Row gutter={16} className="mb-4">
                                                        <Col span={12}>
                                                            <label className="form-label">
                                                                Reason for Leaving <span className="text-danger"> *</span>
                                                            </label>
                                                            <input
                                                                type="text"
                                                                disabled={!editingSections.experience}
                                                                className="form-control"
                                                                placeholder="Enter reason for leaving"
                                                                value={newExperience.reasonForLeaving}
                                                                onChange={(e) =>
                                                                    setNewExperience({
                                                                        ...newExperience,
                                                                        reasonForLeaving: e.target.value,
                                                                    })
                                                                }
                                                            />
                                                        </Col>
                                                        <Col span={12}>
                                                            <label className="form-label">
                                                                Company Location <span className="text-danger"> *</span>
                                                            </label>
                                                            <input
                                                                type="text"
                                                                disabled={!editingSections.experience}
                                                                className="form-control"
                                                                placeholder="Enter Company Location"
                                                                value={newExperience.companyLocation}
                                                                onChange={(e) =>
                                                                    setNewExperience({
                                                                        ...newExperience,
                                                                        companyLocation: e.target.value,
                                                                    })
                                                                }
                                                            />
                                                        </Col>
                                                    </Row>

                                                    <Row gutter={16} className="mb-4">
                                                        <Col span={12}>
                                                            <label className="form-label">
                                                                Salary <span className="text-danger"> *</span>
                                                            </label>
                                                            <input
                                                                type="number"
                                                                disabled={!editingSections.experience}
                                                                className="form-control"
                                                                placeholder="Enter Salary"
                                                                value={newExperience.salary}
                                                                onChange={(e) =>
                                                                    setNewExperience({
                                                                        ...newExperience,
                                                                        salary: e.target.value === "" ? "" : +e.target.value,
                                                                    })
                                                                }
                                                            />
                                                        </Col>
                                                        <Col span={12}>
                                                            <label className="form-label">
                                                                Employment Type <span className="text-danger"> *</span>
                                                            </label>
                                                            <select
                                                                className="form-control"
                                                                disabled={!editingSections.experience}
                                                                value={newExperience.employmentType || "full-time"}
                                                                onChange={(e) =>
                                                                    setNewExperience({
                                                                        ...newExperience,
                                                                        employmentType: e.target.value,
                                                                    })
                                                                }
                                                            >
                                                                <option value="full-time">Full-time</option>
                                                                <option value="part-time">Part-time</option>
                                                                <option value="contract">Contract</option>
                                                                <option value="internship">Internship</option>
                                                            </select>
                                                        </Col>
                                                    </Row>

                                                    <label className="form-label">
                                                        Job Description
                                                    </label>
                                                    <textarea
                                                        className="form-control"
                                                        disabled={!editingSections.experience}
                                                        rows={2}
                                                        placeholder="Describe your responsibilities and achievements in this role"
                                                        value={newExperience.jobDescription}
                                                        onChange={(e) =>
                                                            setNewExperience({
                                                                ...newExperience,
                                                                jobDescription: e.target.value,
                                                            })
                                                        }
                                                    />
                                                </div>
                                            </Card>
                                        </Form>
                                    </>
                                )}

                                {/* Skills Tab */}
                                {activeTab === 'skills' && (
                                    <Form layout="vertical">
                                        <Card
                                            title="Skills"
                                            extra={
                                                <span className="d-inline-block" data-bs-toggle="tooltip" title={modalType === "edit" ? editingSections.skills ? "Save" : "Edit" : "Save"}>
                                                    {modalType === 'edit' ? (
                                                        <Button
                                                            disabled={loadingSkill}
                                                            icon={
                                                                loadingSkill ? (
                                                                    <span className="spinner-border spinner-border-sm" />
                                                                ) : editingSections.skills ? (
                                                                    <CheckOutlined style={{ color: 'green', fontSize: 20 }} />
                                                                ) : (
                                                                    <EditOutlined />
                                                                )
                                                            }
                                                            onClick={async () => {
                                                                if (editingSections.skills) {
                                                                    setLoadingSkill(true);
                                                                    const success = await handleAddOrUpdateAndSaveSkill(true);
                                                                    setLoadingSkill(false);
                                                                    if (success) toggleEdit('skills');
                                                                } else {
                                                                    toggleEdit('skills');
                                                                }
                                                            }}
                                                            style={{
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                gap: 8,
                                                                fontWeight: 500,
                                                            }}
                                                        />
                                                    ) : (
                                                        <Button
                                                            icon={
                                                                loadingSkill ? (
                                                                    <span className="spinner-border spinner-border-sm" />
                                                                ) : editingSections.skills ? (
                                                                    <CheckOutlined style={{ color: 'green', fontSize: 20 }} />
                                                                ) : (
                                                                    <EditOutlined />
                                                                )
                                                            }
                                                            onClick={async () => {
                                                                if (!editingSections.skills) return toggleEdit('skills');
                                                                setLoadingSkill(true);
                                                                const success = await handleAddOrUpdateAndSaveSkill(true);
                                                                setLoadingSkill(false);
                                                                if (success) toggleEdit('skills');
                                                            }}
                                                            style={{
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                gap: 8,
                                                                fontWeight: 500,
                                                            }}
                                                        />
                                                    )}</span>
                                            }
                                        >
                                            {/* Displaying the added skills - Only in edit mode */}
                                            {modalType === 'edit' && (
                                                <div
                                                    className="d-flex overflow-auto pb-3"
                                                    style={{
                                                        gap: "1rem",
                                                        padding: '1%',
                                                        paddingBottom: "1rem",
                                                        whiteSpace: "nowrap",
                                                    }}
                                                >
                                                    {skills.map((skill, index) => (
                                                        <div
                                                            key={index}
                                                            onClick={() => editingSections.skills && handleSelectSkill(index)} // Only allow selection in edit mode
                                                            className={`card p-3 shadow-sm ${index === selectedSkillIndex ? "border-primary" : ""}`}
                                                            style={{
                                                                minWidth: "200px",
                                                                maxWidth: "200px",
                                                                borderRadius: "10px",
                                                                cursor: editingSections.skills ? "pointer" : "default",
                                                                display: "inline-block",
                                                                transition: "transform 0.2s ease",
                                                            }}
                                                            onMouseEnter={(e) => editingSections.skills && (e.currentTarget.style.transform = "scale(1.03)")}
                                                            onMouseLeave={(e) => editingSections.skills && (e.currentTarget.style.transform = "scale(1)")}
                                                        >
                                                            <div className="d-flex justify-content-between align-items-start">
                                                                <div>
                                                                    <h6 className="mb-1">{skill.name}</h6>
                                                                    <p className="mb-0 text-muted" style={{ fontSize: "0.85rem" }}>
                                                                        Proficiency: <b>{skill.proficiency}</b>
                                                                    </p>
                                                                </div>
                                                                <i
                                                                    onClick={(e) => {
                                                                        if (!editingSections.skills) return; // Disable delete in view mode
                                                                        e.stopPropagation();
                                                                        handleDeleteSkill(index);
                                                                    }}
                                                                    className="bi bi-trash"
                                                                    style={{
                                                                        fontSize: "1.2rem",
                                                                        color: editingSections.skills ? "red" : "#ccc",
                                                                        cursor: editingSections.skills ? "pointer" : "not-allowed",
                                                                    }}
                                                                ></i>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            )}

                                            {/* Skill form section (always visible) */}
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="mb-3">
                                                        <label className="form-label">
                                                            Skill Name <span className="text-danger"> *</span>
                                                        </label>
                                                        <select
                                                            className="form-control"
                                                            disabled={!editingSections.skills}
                                                            value={skillName}
                                                            onChange={(e) => setSkillName(e.target.value)}
                                                        >
                                                            <option value="">Select a skill</option>
                                                            {activeSkill
                                                                .filter(
                                                                    (item: any) =>
                                                                        !skills.some(
                                                                            (s, i) =>
                                                                                s.name === item.Name && i !== selectedSkillIndex
                                                                        )
                                                                )
                                                                .slice()
                                                                .sort((a: any, b: any) => a.Name.localeCompare(b.Name))
                                                                .map((item: any) => (
                                                                    <option key={item.Id} value={item.Name}>
                                                                        {item.Name}
                                                                    </option>
                                                                ))}
                                                        </select>
                                                    </div>

                                                </div>
                                                <div className="col-md-6">
                                                    <div className="mb-3">
                                                        <label className="form-label">
                                                            Proficiency Score <span className="text-danger"> *</span>
                                                        </label>
                                                        <input
                                                            type="number"
                                                            className="form-control"
                                                            disabled={!editingSections.skills}
                                                            placeholder="Enter proficiency score (1-10)"
                                                            value={proficiency}
                                                            onChange={(e) => setProficiency(e.target.value)}
                                                            min="1"
                                                            max="10"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </Card>
                                    </Form>
                                )}

                                {/* Education Tab */}
                                {activeTab === 'education' && (
                                    <Form layout="vertical">
                                        <Card
                                            title="Education"
                                            extra={
                                                <span className="d-inline-block" data-bs-toggle="tooltip" title={modalType === "edit" ? editingSections.education ? "Save" : "Edit" : "Save"}>
                                                    <Button
                                                        onClick={async (e) => {
                                                            if (!editingSections.education) {
                                                                setEditingSections(prev => ({ ...prev, education: true }));
                                                                return;
                                                            }
                                                            const success = await handleEducationSubmit(e, false, true);
                                                            if (success) {
                                                                setEditingSections(prev => ({ ...prev, education: false }));
                                                            }
                                                        }}
                                                        icon={
                                                            editingSections.education
                                                                ? (createEmployeeLoading || updateEmployeeLoading
                                                                    ? <span className="spinner-border spinner-border-sm" />
                                                                    : <CheckOutlined style={{ color: "green", fontSize: 20 }} />)
                                                                : <EditOutlined />
                                                        }
                                                        disabled={editingSections.education && (createEmployeeLoading || updateEmployeeLoading)}
                                                        style={{
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            width: 32,
                                                            height: 32
                                                        }}
                                                    /></span>
                                            }
                                        >
                                            <Row gutter={16} className="mb-4">
                                                <Col span={12}>
                                                    <label className="form-label">
                                                        Highest Education<span className="text-danger"> *</span>
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        disabled={!editingSections.education}
                                                        placeholder="Enter degree (e.g., B.Sc., M.A.)"
                                                        name="highestEducation"
                                                        value={educationData.highestEducation}
                                                        onChange={handleEducationChange}
                                                    />
                                                    {educationErrors.highestEducation && (
                                                        <div className="text-danger">
                                                            {educationErrors.highestEducation}
                                                        </div>
                                                    )}
                                                </Col>
                                                <Col span={12}>
                                                    <label className="form-label">
                                                        Field of Study <span className="text-danger"> *</span>
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        disabled={!editingSections.education}
                                                        placeholder="Enter field of study (e.g., Computer Science)"
                                                        name="fieldOfStudy"
                                                        value={educationData.fieldOfStudy}
                                                        onChange={handleEducationChange}
                                                    />
                                                    {educationErrors.fieldOfStudy && (
                                                        <div className="text-danger">
                                                            {educationErrors.fieldOfStudy}
                                                        </div>
                                                    )}
                                                </Col>
                                            </Row>

                                            <Row gutter={16} className="mb-4">
                                                <Col span={12}>
                                                    <label className="form-label">
                                                        Institution Name <span className="text-danger"> *</span>
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        disabled={!editingSections.education}
                                                        placeholder="Enter institution name (e.g., XYZ University)"
                                                        name="institutionName"
                                                        value={educationData.institutionName}
                                                        onChange={handleEducationChange}
                                                    />
                                                    {educationErrors.institutionName && (
                                                        <div className="text-danger">
                                                            {educationErrors.institutionName}
                                                        </div>
                                                    )}
                                                </Col>
                                                <Col span={12}>
                                                    <label className="form-label">
                                                        Graduation Year <span className="text-danger"> *</span>
                                                    </label>
                                                    <input
                                                        type="number"
                                                        className="form-control"
                                                        placeholder="Enter year of graduation"
                                                        disabled={!editingSections.education}
                                                        min="1900"
                                                        max={new Date().getFullYear()}
                                                        name="graduationYear"
                                                        value={educationData.graduationYear}
                                                        onChange={handleEducationChange}
                                                    />
                                                    {educationErrors.graduationYear && (
                                                        <div className="text-danger">
                                                            {educationErrors.graduationYear}
                                                        </div>
                                                    )}
                                                </Col>
                                            </Row>

                                            <Row gutter={16} className="mb-4">
                                                <Col span={12}>
                                                    <label className="form-label">
                                                        Start Date <span className="text-danger"> *</span>
                                                    </label>
                                                    <input
                                                        type="date"
                                                        className="form-control"
                                                        disabled={!editingSections.education}
                                                        value={
                                                            educationData.startDate instanceof Date
                                                                ? educationData.startDate
                                                                    .toISOString()
                                                                    .split("T")[0]
                                                                : ""
                                                        }
                                                        onChange={(e) =>
                                                            setEducationData({
                                                                ...educationData,
                                                                startDate: e.target.value
                                                                    ? new Date(e.target.value)
                                                                    : null,
                                                            })
                                                        }
                                                        placeholder="DD-MM-YYYY"
                                                    />
                                                    {educationErrors.startDate && (
                                                        <div className="text-danger">
                                                            {educationErrors.startDate}
                                                        </div>
                                                    )}
                                                </Col>
                                                <Col span={12}>
                                                    <label className="form-label">
                                                        End Date <span className="text-danger"> *</span>
                                                    </label>
                                                    <input
                                                        type="date"
                                                        className="form-control"
                                                        disabled={!editingSections.education}
                                                        value={
                                                            educationData.endDate instanceof Date &&
                                                                !isNaN(educationData.endDate.getTime())
                                                                ? educationData.endDate.toISOString().split("T")[0]
                                                                : ""
                                                        }
                                                        onChange={(e) =>
                                                            setEducationData({
                                                                ...educationData,
                                                                endDate: e.target.value
                                                                    ? new Date(e.target.value)
                                                                    : null,
                                                            })
                                                        }
                                                    />
                                                    {educationErrors.endDate && (
                                                        <div className="text-danger">
                                                            {educationErrors.endDate}
                                                        </div>
                                                    )}
                                                </Col>
                                            </Row>

                                            <Row gutter={16} className="mb-4">
                                                <Col span={12}>
                                                    <label className="form-label">
                                                        Address<span className="text-danger"> *</span>
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Institute Address"
                                                        disabled={!editingSections.education}
                                                        name="address"
                                                        value={educationData.address}
                                                        onChange={handleEducationChange}
                                                    />
                                                    {educationErrors.address && (
                                                        <div className="text-danger">
                                                            {educationErrors.address}
                                                        </div>
                                                    )}
                                                </Col>
                                                <Col span={12}>
                                                    <label className="form-label">GPA (Optional)</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        disabled={!editingSections.education}
                                                        placeholder="Enter GPA (optional)"
                                                        name="gpa"
                                                        value={educationData.gpa}
                                                        onChange={handleEducationChange}
                                                    />
                                                </Col>
                                            </Row>
                                            <label className="form-label">
                                                Description (Optional)
                                            </label>
                                            <textarea
                                                className="form-control"
                                                disabled={!editingSections.education}
                                                rows={3}
                                                placeholder="Enter any additional details (optional)"
                                                name="shortNote"
                                                value={educationData.shortNote}
                                                onChange={handleEducationChange}
                                            />
                                        </Card>
                                    </Form>
                                )}

                                {/* Leave Tab */}
                                {activeTab === 'leave' && (
                                    <Form layout="vertical">
                                        <Card
                                            title="Leave Information"
                                            extra={
                                                <span className="d-inline-block" data-bs-toggle="tooltip" title={modalType === "edit" ? editingSections.leave ? "Save" : "Edit" : "Save"}>
                                                    {modalType === 'edit' ? (
                                                        <Button
                                                            disabled={loadingLeave}
                                                            icon={
                                                                loadingLeave ? (
                                                                    <span className="spinner-border spinner-border-sm" />
                                                                ) : editingSections.leave ? (
                                                                    <CheckOutlined style={{ color: 'green', fontSize: 20 }} />
                                                                ) : (
                                                                    <EditOutlined />
                                                                )
                                                            }
                                                            onClick={async () => {
                                                                if (!editingSections.leave) return toggleEdit('leave');
                                                                setLoadingLeave(true);
                                                                const success = await handleAddAndSaveLeaves(true);
                                                                setLoadingLeave(false);
                                                                if (success) toggleEdit('leave');
                                                            }}

                                                            style={{
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                gap: 8,
                                                                fontWeight: 500,
                                                            }}
                                                        />
                                                    ) : (
                                                        <Button
                                                            icon={
                                                                loadingLeave ? (
                                                                    <span className="spinner-border spinner-border-sm" />
                                                                ) : editingSections.leave ? (
                                                                    <CheckOutlined style={{ color: 'green', fontSize: 20 }} />
                                                                ) : (
                                                                    <EditOutlined />
                                                                )
                                                            }
                                                            onClick={async () => {
                                                                if (!editingSections.leave) return toggleEdit('leave');
                                                                setLoadingLeave(true);
                                                                const success = await handleAddAndSaveLeaves(false);
                                                                setLoadingLeave(false);
                                                                if (success) toggleEdit('leave');
                                                            }}
                                                            style={{
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                gap: 8,
                                                                fontWeight: 500,
                                                            }}
                                                        />
                                                    )}</span>
                                            }
                                        >
                                            {modalType === "edit" && Array.isArray(leaves) && leaves.length > 0 && (
                                                <div
                                                    className="d-flex overflow-auto pb-3"
                                                    style={{
                                                        gap: "1rem",
                                                        padding: "1%",
                                                        paddingBottom: "1rem",
                                                        whiteSpace: "nowrap",
                                                    }}
                                                >
                                                    {leaves.map((leave, index) => (
                                                        <div
                                                            key={index}
                                                            onClick={() => handleEditLeave(index)}
                                                            className="card p-3 shadow-sm"
                                                            style={{
                                                                minWidth: "200px",
                                                                maxWidth: "200px",
                                                                borderRadius: "10px",
                                                                cursor: "pointer",
                                                                display: "inline-block",
                                                                transition: "transform 0.2s ease",
                                                            }}
                                                            onMouseEnter={(e) =>
                                                                (e.currentTarget.style.transform = "scale(1.03)")
                                                            }
                                                            onMouseLeave={(e) =>
                                                                (e.currentTarget.style.transform = "scale(1)")
                                                            }
                                                        >
                                                            <div className="d-flex justify-content-between align-items-start">
                                                                <div>
                                                                    <h6 className="mb-1">
                                                                        {filteredLeaveTypes.find(
                                                                            (lt: any) => lt.Id.toString() === leave.LeaveType
                                                                        )?.Name || "Leave"}
                                                                    </h6>
                                                                    <p className="mb-0 text-muted" style={{ fontSize: "0.85rem" }}>
                                                                        {leave.NumberOfDays} day(s)
                                                                    </p>
                                                                    <p className="mb-0 text-muted" style={{ fontSize: "0.8rem" }}>
                                                                        From: {leave.ApplicableFrom ? dayjs(leave.ApplicableFrom).format("DD-MM-YYYY") : ""}
                                                                    </p>
                                                                </div>
                                                                <i
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        handleDeleteLeave(index);
                                                                    }}
                                                                    className="bi bi-trash"
                                                                    style={{
                                                                        fontSize: "1.2rem",
                                                                        color: "red",
                                                                        cursor: "pointer",
                                                                    }}
                                                                ></i>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            )}

                                            <Row gutter={16} className="mb-4">
                                                <Col span={12}>
                                                    <label className="form-label">
                                                        Leave Type <span className="text-danger">*</span>
                                                    </label>
                                                    <select
                                                        className="form-control"
                                                        value={leaveForm.LeaveType}
                                                        disabled={!editingSections.leave}
                                                        onChange={(e) => {
                                                            const selectedId = e.target.value;
                                                            const selectedLeave = leaveTypes.find(
                                                                (leave: any) => leave.Id.toString() === selectedId
                                                            );

                                                            setLeaveForm({
                                                                ...leaveForm,
                                                                LeaveType: selectedId,
                                                                Frequency: selectedLeave?.Frequency || "",
                                                            });
                                                        }}
                                                    >
                                                        <option value="">Select Leave Type</option>
                                                        {filteredLeaveTypes
                                                            .filter(
                                                                (item: any) =>
                                                                    !leaves.some(
                                                                        (s, i) =>
                                                                            s.LeaveType === item.Id.toString() && i !== selectedLeaveIndex
                                                                    )
                                                            )
                                                            .map((leave: any) => (
                                                                <option key={leave.Id} value={leave.Id}>
                                                                    {leave.Name}
                                                                </option>
                                                            ))}
                                                    </select>
                                                </Col>

                                                <Col span={12}>
                                                    <label className="form-label">Number of Days <span className="text-danger">*</span></label>
                                                    <input
                                                        type="number"
                                                        disabled={!editingSections.leave}
                                                        className="form-control"
                                                        value={leaveForm.NumberOfDays}
                                                        onChange={(e) =>
                                                            setLeaveForm({
                                                                ...leaveForm,
                                                                NumberOfDays: e.target.value === "" ? "" : +e.target.value,
                                                            })
                                                        }
                                                    />
                                                </Col>
                                                <Col span={12}>
                                                    <label className="form-label" style={{ marginTop: "10px" }}>Opening Balance </label>
                                                    <input
                                                        type="number"
                                                        step="any"
                                                        min={-999999}
                                                        disabled={!editingSections.leave}
                                                        className="form-control"
                                                        value={leaveForm.OpeningBalance}
                                                        onChange={(e) =>
                                                            setLeaveForm({
                                                                ...leaveForm,
                                                                OpeningBalance: e.target.value === "" ? 0 : +e.target.value,
                                                            })
                                                        }
                                                    />
                                                </Col>
                                                <Col span={12}>
                                                    <label className="form-label" style={{ marginTop: "10px" }}>Applicable From <span className="text-danger">*</span></label>
                                                    <input
                                                        type="date"
                                                        disabled={!editingSections.leave}
                                                        className="form-control"
                                                        value={leaveForm.ApplicableFrom ? dayjs(leaveForm.ApplicableFrom).format("YYYY-MM-DD") : ""}
                                                        onChange={(e) =>
                                                            setLeaveForm({ ...leaveForm, ApplicableFrom: e.target.value })
                                                        }
                                                    />
                                                </Col>
                                            </Row>
                                        </Card>
                                    </Form>
                                )}

                                {/* Documents Tab */}
                                {activeTab === 'documents' && (
                                    <Form layout="vertical">
                                        <Card
                                            title="Documents"
                                            extra={
                                                <span className="d-inline-block" data-bs-toggle="tooltip" title={modalType === "edit" ? editingSections.document ? "Save" : "Edit" : "Save"}>
                                                    {modalType === 'edit' ? (
                                                        <Button
                                                            disabled={loadingDocument}
                                                            icon={
                                                                loadingDocument ? (
                                                                    <span className="spinner-border spinner-border-sm" />
                                                                ) : editingSections.document ? (
                                                                    <CheckOutlined style={{ color: 'green', fontSize: 20 }} />
                                                                ) : (
                                                                    <EditOutlined />
                                                                )
                                                            }
                                                            onClick={async () => {
                                                                if (!editingSections.document) return toggleEdit('document');
                                                                setLoadingDocument(true);
                                                                const success = await handleAddAndSaveDocument(true);
                                                                setLoadingDocument(false);
                                                                if (success) toggleEdit('document');
                                                            }}
                                                            style={{
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                gap: 8,
                                                                fontWeight: 500,
                                                            }}
                                                        />
                                                    ) : (
                                                        <Button
                                                            icon={
                                                                loadingDocument ? (<span className="spinner-border spinner-border-sm" />) : editingSections.document ? (<CheckOutlined style={{ color: 'green', fontSize: 20 }} />) : (<EditOutlined />)}
                                                            onClick={async () => {
                                                                if (!editingSections.document) {
                                                                    toggleEdit("document");
                                                                    return;
                                                                }
                                                                setLoadingDocument(true);
                                                                const success = await handleAddAndSaveDocument(true);
                                                                setLoadingDocument(false);
                                                                if (success) toggleEdit("document");
                                                            }}
                                                            style={{ display: 'flex', alignItems: 'center', gap: 8, fontWeight: 500 }}
                                                        />
                                                    )}</span>
                                            }
                                        >
                                            <div className="modal-body pb-0">
                                                {modalType === "edit" && (
                                                    <div className="mb-4">
                                                        <div
                                                            className="d-flex overflow-auto pb-3"
                                                            style={{
                                                                gap: "1rem",
                                                                padding: '1%',
                                                                paddingBottom: "1rem",
                                                                whiteSpace: "nowrap",
                                                            }}
                                                        >
                                                            {documents.map((doc, index) => (
                                                                <div
                                                                    key={index}
                                                                    onClick={() => handleEditDocument(index)}
                                                                    className={`card p-3 shadow-sm`}
                                                                    style={{
                                                                        minWidth: "240px",
                                                                        maxWidth: "240px",
                                                                        borderRadius: "10px",
                                                                        cursor: "pointer",
                                                                        display: "inline-block",
                                                                        transition: "transform 0.2s ease",
                                                                    }}
                                                                    onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.03)")}
                                                                    onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
                                                                >
                                                                    <div className="d-flex justify-content-between align-items-start">
                                                                        <div>
                                                                            <h6 className="mb-1">{doc.Name || doc.documentType || "Document"}</h6>
                                                                            <p className="mb-0 text-muted" style={{ fontSize: "0.85rem" }}>
                                                                                Number: <b>{doc.documentNumber}</b>
                                                                            </p>
                                                                        </div>
                                                                        <i
                                                                            onClick={(e) => {
                                                                                e.stopPropagation();
                                                                                handleDeleteDocument(index);
                                                                            }}
                                                                            className="bi bi-x-circle"
                                                                            style={{
                                                                                fontSize: "1.2rem",
                                                                                color: "red",
                                                                                cursor: "pointer",
                                                                            }}
                                                                        ></i>
                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>
                                                )}

                                                <Row gutter={16} className="mb-4">
                                                    <Col span={12}>
                                                        <label className="form-label">
                                                            Document Type <span className="text-danger"> *</span>
                                                        </label>
                                                        <select
                                                            className="form-control"
                                                            disabled={!editingSections.document}
                                                            value={documentType}
                                                            onChange={(e) => setDocumentType(e.target.value)}
                                                        >
                                                            {documentTypes
                                                                .filter(
                                                                    (type) => type === "other" || !addedTypes.includes(type)
                                                                )
                                                                .map((type) => (
                                                                    <option key={type} value={type}>
                                                                        {type.replace("-", " ").toUpperCase()}
                                                                    </option>
                                                                ))}
                                                        </select>
                                                    </Col>
                                                    <Col span={12}>
                                                        <label className="form-label">Document Number<span className="text-danger"> *</span></label>
                                                        <input
                                                            type="text"
                                                            disabled={!editingSections.document}
                                                            className={`form-control ${docNumberError ? "is-invalid" : ""}`}
                                                            value={documentNumber}
                                                            onChange={(e) => setDocumentNumber(e.target.value)}
                                                            placeholder="Document number"
                                                        />
                                                        {docNumberError && <div className="invalid-feedback">{docNumberError}</div>}
                                                    </Col>
                                                </Row>

                                                <Row gutter={16}>
                                                    <Col span={12}>
                                                        <label className="form-label">
                                                            Document Image/PDF<span className="text-danger"> *</span>
                                                        </label>

                                                        <div className="input-group">
                                                            {/* Show file name (new or from backend) */}
                                                            <input
                                                                type="text"
                                                                className={`form-control ${fileError ? "is-invalid" : ""}`}
                                                                value={file?.name ?? fileName ?? ""}
                                                                placeholder="No file chosen"
                                                                readOnly
                                                                disabled={!editingSections.document}
                                                            />

                                                            {/* Hidden real file input */}
                                                            <input
                                                                ref={fileInputRef}
                                                                type="file"
                                                                accept="image/*,application/pdf"
                                                                disabled={!editingSections.document}
                                                                style={{ display: "none" }}
                                                                onChange={(e) => {
                                                                    const selectedFile = e.target.files?.[0] ?? null;
                                                                    setFile(selectedFile);
                                                                    setFileName(selectedFile ? selectedFile.name : "");
                                                                    if (selectedFile) setFilePreview(URL.createObjectURL(selectedFile));
                                                                }}
                                                            />
                                                            {/* Browse button */}
                                                            <button
                                                                type="button"
                                                                disabled={!editingSections.document}
                                                                className="btn btn-outline-secondary"
                                                                onClick={() => fileInputRef.current?.click()}
                                                            >
                                                                Browse
                                                            </button>
                                                        </div>
                                                        <small className="form-text text-muted">
                                                            Upload document as image or PDF (Max. 4 MB)
                                                        </small>
                                                        {fileError && <div className="invalid-feedback">{fileError}</div>}
                                                    </Col>
                                                    <Col span={12}>
                                                        <label className="form-label">
                                                            Additional Notes (Optional)
                                                        </label>
                                                        <textarea
                                                            className="form-control"
                                                            disabled={!editingSections.document}
                                                            rows={3}
                                                            value={additionalNotes}
                                                            onChange={(e) => setAdditionalNotes(e.target.value)}
                                                            placeholder="Enter any additional details about the document (optional)"
                                                        />
                                                    </Col>
                                                    <Col span={12} className="mt-1">
                                                        <div>
                                                            <label className="form-label">
                                                                Access <span className="text-danger"> *</span>
                                                            </label>
                                                        </div>

                                                        <Select
                                                            disabled={!editingSections.document}
                                                            value={accessDoc}
                                                            onChange={(value) => setAccessDoc(value)}
                                                            style={{ width: 400 }}
                                                        >
                                                            <Select.Option value="view">view</Select.Option>
                                                            <Select.Option value="download">download</Select.Option>
                                                            <Select.Option value="all">all</Select.Option>
                                                        </Select>

                                                    </Col>
                                                </Row>
                                            </div>
                                        </Card>
                                    </Form>
                                )}

                                {/* Salary Structure */}
                                {activeTab === "salary structure" && (
                                    <Form layout="vertical">
                                        <Card
                                            title="Salary Structure"
                                            extra={
                                                <span className="d-inline-block" data-bs-toggle="tooltip" title={modalType === "edit" ? editingSections.experience ? "Save" : "Edit" : "Save"}>
                                                    {modalType === "edit" ? (
                                                        <Button
                                                            disabled={loadingSalary}
                                                            icon={
                                                                editingSlaryStruct.EditsalaryStructure ? (
                                                                    <CheckOutlined style={{ color: "green", fontSize: 20 }} />
                                                                ) : (
                                                                    <EditOutlined style={{ fontSize: 20 }} />
                                                                )
                                                            }
                                                            onClick={async () => {
                                                                if (editingSlaryStruct.EditsalaryStructure) {
                                                                    setLoadingSalary(true);
                                                                    let success = false;

                                                                    if (salaryStructRef.current) {
                                                                        success = await salaryStructRef.current.handleSubmit(true);
                                                                    }
                                                                    setLoadingSalary(false);
                                                                    if (success) toggleEditSalaryStruct("EditsalaryStructure");
                                                                } else {
                                                                    const allSalaryStructures = salaryStructRef.current?.salaryStructures || [];
                                                                    const record = allSalaryStructures.find(
                                                                        (s: any) => s.employee_id === selectedRowData?.EmployeeID
                                                                    );

                                                                    if (salaryStructRef.current) {
                                                                        if (record) {
                                                                            salaryStructRef.current.showEditHeadsUp(record);
                                                                        }
                                                                        toggleEditSalaryStruct("EditsalaryStructure");
                                                                        // await salaryStructRef.current.handleSubmit(true); // <-- direct save

                                                                    }
                                                                }
                                                            }}
                                                        />

                                                    ) : (
                                                        <Button
                                                            icon={<CheckOutlined style={{ color: "green", fontSize: 20 }} />}
                                                            onClick={async () => {
                                                                if (salaryStructRef.current) {
                                                                    await salaryStructRef.current.handleSubmit(undefined, true);
                                                                }
                                                            }}
                                                            style={{
                                                                display: "flex",
                                                                alignItems: "center",
                                                                gap: 8,
                                                                fontWeight: 500,
                                                            }}
                                                        />
                                                    )}</span>
                                            }
                                        >
                                            <EmployeeSalaryStructureModal
                                                ref={salaryStructRef}
                                                modalType={modalType}
                                                selectedRowData={selectedRowData}
                                                isModalVisible={isModalVisible}
                                                // record={record}
                                                setIsModalVisible={setIsModalVisible}
                                                setTableKey={setTableKey}
                                                employeeId={selectedRowData?.EmployeeID}
                                                editingSlaryStruct={editingSlaryStruct}
                                                setEditingSalaryStruct={setEditingSalaryStruct}
                                            />
                                        </Card>
                                    </Form>
                                )}
                            </div>
                        </div>
                    </div>
                </form >
            </Drawer >
            <DeleteModal1
                isVisible={isDeleteModalVisible}
                onClose={() => setIsDeleteModalVisible(false)}
                onConfirm={() =>
                    selectedRowData?.EmployeeID &&
                    handleDeleteEmployee(selectedRowData.EmployeeID)
                }
            />

            <Drawer
                title={<span style={{ fontWeight: "bold" }}>View Employee Log</span>}
                open={viewModalOpen}
                onClose={() => setViewModalOpen(false)}
                placement="right"
                width="700px"
                style={{ marginTop: 50, paddingBottom: 50 }}
            >
                <div style={{ padding: "10px" }}>
                    {Array.isArray(employeelogs) && employeelogs.length > 0 && (
                        <p
                            style={{
                                fontSize: "16px",
                                fontWeight: 600,
                                marginBottom: "20px",
                                color: "#4a4a4a",
                            }}
                        >
                            👤 <strong>Employee Name:</strong>{" "}
                            {employeelogs[0]?.employee_name || ""}
                        </p>
                    )}

                    {Array.isArray(employeelogs) &&
                        employeelogs.map((log: any) => {
                            const oldDataParsed =
                                Array.isArray(log.old_data_parsed) && log.old_data_parsed.length > 0
                                    ? log.old_data_parsed[0]
                                    : null;

                            const newDataParsed =
                                Array.isArray(log.new_data_parsed) && log.new_data_parsed.length > 0
                                    ? log.new_data_parsed[0]
                                    : null;

                            return (
                                <div
                                    key={log.log_id}
                                    style={{
                                        borderRadius: "10px",
                                        background: "linear-gradient(to right, #f0faff, #ffffff)",
                                        padding: "15px",
                                        marginBottom: "20px",
                                        boxShadow: "0 4px 10px rgba(0,0,0,0.06)",
                                    }}
                                >
                                    <p
                                        style={{ fontWeight: 600, fontSize: "15px", color: "#333" }}
                                    >
                                        🔧 Action:{" "}
                                        <span style={{ color: "#1677ff" }}>
                                            {log.action_type || "N/A"}
                                        </span>
                                        <span style={{ color: "#1677ff" }}>
                                            {" "}{formatFullDateTime(log.created_at, config)}
                                        </span>
                                    </p>
                                    <p style={{ marginBottom: "10px", color: "#555" }}>
                                        📝 <strong>Description:</strong> {log.description || ""}
                                    </p>

                                    {/* Old Data */}
                                    {oldDataParsed && (
                                        <details style={{ marginTop: "10px" }}>
                                            <summary
                                                style={{
                                                    fontWeight: "bold",
                                                    cursor: "pointer",
                                                    color: "#d46b08",
                                                }}
                                            >
                                                📁 Old Data
                                            </summary>
                                            <table>
                                                <thead>
                                                    <tr>
                                                        <th style={headerCellStyle}>Field</th>
                                                        <th style={headerCellStyle}>Value</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {Object.entries(oldDataParsed)
                                                        .filter(([key, value]) => {
                                                            // Skip picture & PictureURL
                                                            if (key.toLowerCase() === "picture" || key.toLowerCase() === "pictureurl") return false;
                                                            const strVal = String(value ?? "");
                                                            return (
                                                                /[a-zA-Z]/.test(strVal) || /^\d{4}-\d{2}-\d{2}$/.test(strVal)
                                                            );
                                                        })
                                                        .map(([key, value]) => {
                                                            let formattedValue = String(value ?? "");

                                                            // Format date (YYYY-MM-DD → DD-MM-YYYY)
                                                            if (/^\d{4}-\d{2}-\d{2}/.test(formattedValue)) {
                                                                formattedValue = dayjs(formattedValue).format("DD-MM-YYYY");
                                                            }
                                                            return (
                                                                <tr key={key} style={rowHoverStyle}>
                                                                    <td style={cellStyle}>{key}</td>
                                                                    <td style={cellStyle}>{formattedValue}</td>
                                                                </tr>
                                                            );
                                                        })}
                                                </tbody>
                                            </table>
                                        </details>
                                    )}

                                    {/* New Data */}
                                    {newDataParsed && (
                                        <details style={{ marginTop: "10px" }}>
                                            <summary
                                                style={{
                                                    fontWeight: "bold",
                                                    cursor: "pointer",
                                                    color: "#096dd9",
                                                }}
                                            >
                                                📘 New Data
                                            </summary>
                                            <table>
                                                <thead>
                                                    <tr>
                                                        <th style={headerCellStyle}>Field</th>
                                                        <th style={headerCellStyle}>Value</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {Object.entries(newDataParsed)
                                                        .filter(([key, value]) => {
                                                            // Skip picture & PictureURL
                                                            if (key.toLowerCase() === "picture" || key.toLowerCase() === "pictureurl") return false;
                                                            const strVal = String(value ?? "");
                                                            return (
                                                                /[a-zA-Z]/.test(strVal) || /^\d{4}-\d{2}-\d{2}/.test(strVal)
                                                            );
                                                        })
                                                        .map(([key, value]) => {
                                                            let formattedValue = String(value ?? "");

                                                            // Format date using dayjs
                                                            if (/^\d{4}-\d{2}-\d{2}/.test(formattedValue)) {
                                                                formattedValue = dayjs(formattedValue).format("DD-MM-YYYY");
                                                            }

                                                            return (
                                                                <tr key={key} style={rowHoverStyle}>
                                                                    <td style={cellStyle}>{key}</td>
                                                                    <td style={cellStyle}>{formattedValue}</td>
                                                                </tr>
                                                            );
                                                        })}
                                                </tbody>
                                            </table>
                                        </details>
                                    )}
                                </div>
                            );
                        })}
                </div>
            </Drawer>
        </>
    );
};
export default EmployeeList;
